/* eslint-disable */
/* eslint-disable no-unused-vars */
import {
  Card,
  Collapse,
  FormInstance,
  Image,
  Typography,
  Space,
  Button,
  Tooltip,
  Spin,
  Select,
  Form,
  Input,
  Modal,
  Radio,
} from 'antd';
import JSZip from 'jszip';
import { useState, useEffect, useRef } from 'react';

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  MailOutlined,
  PlusOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { InputInterface } from '../utils/forms/FormInterface';
import PhotoRemarksModal from './PhotoRemarksModal';
import { fallback } from '../constants/FallbackImage';
import {
  APPLICATION_FORM_PACKAGES,
  APPLICATION_FORM_SERVICES,
  DOCUMENT_ACCEPT_REJECT,
  DOCUMENT_MARK_DUPLICATE,
  DOCUMENT_TYPE_UPDATE,
  DOCUMENT_DELETE_BY_MEMBER,
  DOCUMENT_DELETE_SINGLE,
  DOCUMITRA_ORDER_PROCESSED_PDF,
  DOCUMITRA_ORDER_BULK_PROCESSED_PDF,
  CHECK_EXISTING_PDF,
  BULK_UPDATE_PDFS,
  ORDER_USER,
  DOCUMENT_USER_ADDITIONAL_DETAILS,
  DOCUMITRA_MEMBER_NOTES,
} from '../constants/EntityName';
import callApi, { uploadImageApiCall } from '../Api/config';
import UserDetails from './UserDetails';
import PaymentDetails from './PaymentDetails';
import { getRole } from '../service/CookieManager';
import { toastError, toastSuccess, toastWarning } from '../service/Toast';
import DocumitraAdditionalDetail from './DocumitraAdditionalDetail';
import FinalEmailTrackingDetail from './FinalEmailTrackingDetail';
import { BASE_IMAGE_URL, BASE_API_URL } from '../env';
import PdfViewer from './PdfViewer';
import { DownloadMergedPdf } from './DownloadMergedPdf/DownloadMergedPdf';
import { getToken } from '../service/CookieManager';
import {
  getDocumitraAdminStatusValue,
  getDocumitraGovernmentStatusOptions,
  getDocumitraMemberStatusOptionsByPlan,
  isDocumitraMemberOnHold,
  isDocumitraMemberRejectedByAuthority,
  isDocumitraRejectedByAuthorityStatus,
} from '../constants/AppConstant';
import {
  DOCUMENT_CATEGORIES,
  getDocumentTypesForCategory,
  DOCUMENT_TYPE_TAXONOMY,
} from '../constants/DocumentTypes';
import './ReviewDocumitraOrder.scss';
import { InvertFillButton } from './InvertFillButton';
import HorizontalTabNavigation, {
  HorizontalTabPanel,
} from './HorizontalTabNavigation/HorizontalTabNavigation';
import HorizontalTabsSec, {
  HorizontalTabsSecPanel,
} from './HorizontalTabNavigation/HorizontalTabsSec';
import {
  Barcode,
  ChartNoAxesGantt,
  Check,
  CircleCheckBig,
  CircleX,
  Clipboard,
  ClipboardList,
  Copy,
  CreditCard,
  Download,
  ExternalLink,
  FileStack,
  History,
  IdCard,
  ImagePlus,
  LineChart,
  Package,
  PauseCircle,
  Pencil,
  PlayCircle,
  ScanLine,
  Stamp,
  Truck,
  TruckIcon,
  User,
  Zap,
} from 'lucide-react';
import OrderStageHistory from './OrderStageHistory';
import DocumentReminderPanel from './DocumentReminderPanel';
import DocumentReminderHistory from './DocumentReminderHistory';
import DocumitraTeamDocuments from './DocumitraTeamDocuments';
import {
  PROCESSED_DOCUMENT_TYPES,
  PREVIEW_FORM_RETENTION_DAYS,
  isPreviewProcessedDocument,
} from '../constants/ProcessedDocumentTypes';
import type { RefundRequest } from '../pages/RefundRequests';
import { getApostilleLabel } from '../utils/apostille';

const { Panel } = Collapse;
const { Title, Text } = Typography;
const governmentStatusOptions = getDocumitraGovernmentStatusOptions();
const governmentStatusValues = governmentStatusOptions.map((option: any) => option.value);
const governmentStatusSelectOptions = governmentStatusOptions.map((option: any) => ({
  label: option.name,
  value: option.value,
}));
const FINAL_EMAIL_STATUS = 'Final Email to be sent';
const GOVERNMENT_FEE_PENDING_STATUS = 'Government Fee payment pending';
/** What the government fee payment covers (Documitra Emails V2 §9.6) */
const GOVERNMENT_FEE_PAYMENT_FOR_OPTIONS = [
  'Government Fee',
  'Courier Fee',
  'Government fee including courier charges',
];
const addonTile = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '9px 10px',
  borderRadius: '10px',
  border: '1px solid #e5e7eb',
  backgroundColor: '#f9fafb',
  color: '#1e293b',
  fontSize: '13px',
  fontWeight: 600,
};

const addonCheck = {
  width: '18px',
  height: '18px',
  flexShrink: 0,
  borderRadius: '50%',
  backgroundColor: '#10b981',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const checkIcon = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const Field = ({ label, value }: { label: React.ReactNode; value?: React.ReactNode }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
    <span
      style={{
        fontSize: '13px',
        fontWeight: 600,
        color: '#53657f',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
      }}
    >
      {label}
    </span>
    <span style={{ fontSize: '15px', fontWeight: 600, color: '#1e293b' }}>{value || '—'}</span>
  </div>
);

const isAddonSelected = (addon: any) => {
  const selected = addon?.selected;
  return (
    selected === true ||
    ['true', 'yes', 'selected'].includes(
      String(selected || '')
        .trim()
        .toLowerCase()
    )
  );
};

interface revieworderProps {
  formInput: InputInterface;
  index: number;
  form: FormInstance;
  isCreateMode?: boolean;
  additionalData?: any;
  formDetails?: any;
  onPrimaryTabChange?: (tabId: string) => void;
}

type PresignedContent = { id: any; data: any } | null;
const ReviewDocumitraOrder = (props: revieworderProps) => {
  const { formDetails, onPrimaryTabChange } = props;
  const [trackingDetailsForm] = Form.useForm();
  const [members, setMembers] = useState<any>([]);
  const [savedMemberStatuses, setSavedMemberStatuses] = useState<{ [key: string]: string }>({});
  const [trackingDetailsModal, setTrackingDetailsModal] = useState<{
    open: boolean;
    member?: any;
    status?: string;
  }>({ open: false });
  const [trackingDetailsSaving, setTrackingDetailsSaving] = useState(false);
  // Read-only "View" modal for showing already-saved Final Email tracking
  // details next to the application-status Update button.
  const [viewFinalEmailModal, setViewFinalEmailModal] = useState<{
    open: boolean;
    member?: any;
  }>({ open: false });
  const [activePhoto, setActivePhoto] = useState<any>({});
  const [activeDocName, setActiveDocName] = useState<string>('');
  const [activeRemarkPresets, setActiveRemarkPresets] = useState<string[]>([]);
  const [openAddRemark, setOpenAddRemarks] = useState<boolean>(false);
  const [paymentDetails, setPaymentDetails] = useState<any>({});
  const [userDetails, setUserDetails] = useState<any>({});

  const [pdfData, setPdfData] = useState<any>();
  const [pdfUrl, setPdfUrl] = useState<any>();
  const [memberId, setMemberId] = useState();
  const [processedDocuments, setProcessedDocuments] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);
  const [serviceName, setServiceName] = useState('');
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [combinedPdfLoading, setCombinedPdfLoading] = useState(false);
  const [mergeLoadingStates, setMergeLoadingStates] = useState<{ [key: string]: boolean }>({});
  const [addPdfLoadingStates, setAddPdfLoadingStates] = useState<{ [key: string]: boolean }>({});
  const [existingPdfStatus, setExistingPdfStatus] = useState<{ [key: string]: any }>({});
  const [updatePdfLoadingStates, setUpdatePdfLoadingStates] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [updateAllLoading, setUpdateAllLoading] = useState(false);
  const [deleteLoadingStates, setDeleteLoadingStates] = useState<{ [key: string]: boolean }>({});
  const [documentActionLoadingStates, setDocumentActionLoadingStates] = useState<
    Record<string, boolean>
  >({});
  const documentActionsInFlight = useRef<Set<string>>(new Set());
  const [memberStatusLoadingStates, setMemberStatusLoadingStates] = useState<{
    [key: string]: boolean;
  }>({});
  const [paymentStatusLoading, setPaymentStatusLoading] = useState<boolean>(false);
  const [activePrimaryTab, setActivePrimaryTab] = useState<string>('user-details');
  const [hasAutoSelectedMemberTab, setHasAutoSelectedMemberTab] = useState<boolean>(false);
  const [activeSecondaryTabs, setActiveSecondaryTabs] = useState<{ [memberId: string]: string }>(
    {}
  );
  const [orderIdCopied, setOrderIdCopied] = useState<boolean>(false);
  const [selectedMissingDocumentIds, setSelectedMissingDocumentIds] = useState<string[]>([]);
  const [reminderHistoryRefreshKey, setReminderHistoryRefreshKey] = useState(0);
  const [orderRefund, setOrderRefund] = useState<RefundRequest | null>(null);
  // Draft remark typed for "Application Rejected by Authority" (per member) before it is saved
  const [governmentRemarkDrafts, setGovernmentRemarkDrafts] = useState<{
    [memberId: string]: string;
  }>({});
  // Outcome under "Application Rejected by Authority": Rejected (redo form) or Withdrawal
  const [rejectionOutcomeDrafts, setRejectionOutcomeDrafts] = useState<{
    [memberId: string]: 'rejected' | 'withdrawal';
  }>({});
  // Government fee details entered when setting "Government Fee payment pending" (emailed to the applicant)
  const [governmentFeeDrafts, setGovernmentFeeDrafts] = useState<{
    [memberId: string]: { paymentAmount: string; paymentFor: string };
  }>({});
  // "On Hold" tag toggled from the member left panel
  const [holdModal, setHoldModal] = useState<{ open: boolean; member?: any }>({ open: false });
  const [holdRemark, setHoldRemark] = useState<string>('');
  const [holdSaving, setHoldSaving] = useState<boolean>(false);

  const mapFormDetailsToRefundRequest = (details: any): RefundRequest | null => {
    const summary = details?.refundSummary;
    if (!summary?.id && !summary?.refundRequestId) return null;

    const status = String(summary.status || details?.refundStatus || 'PENDING').toUpperCase() as
      | 'PENDING'
      | 'APPROVED'
      | 'REJECTED'
      | 'REFUNDED';

    return {
      id: summary.id || summary.refundRequestId,
      userId: details?.userId || '',
      name: summary.applicantName || details?.user?.name || details?.name || '',
      applicantName: summary.applicantName,
      email: summary.email || details?.user?.email || details?.email || '',
      applicationType: summary.applicationType || details?.serviceName || '',
      refundReason: summary.refundReason || '',
      paymentMethod:
        summary.paymentMethod ||
        details?.paymentDetails?.paymentMethod ||
        details?.paymentMethod ||
        '',
      cardHolderName:
        summary.cardHolderName ||
        details?.paymentDetails?.cardHolderName ||
        details?.cardHolderName,
      lastFourDigits:
        summary.lastFourDigits ||
        details?.paymentDetails?.lastFourDigits ||
        details?.lastFourDigits,
      venmoId:
        summary.venmoId ||
        summary.venmo ||
        details?.paymentDetails?.venmo ||
        details?.venmo ||
        details?.venmoId,
      zelleId:
        summary.zelleId ||
        summary.zelle ||
        details?.paymentDetails?.zelle ||
        details?.zelle ||
        details?.zelleId,
      amountPaid: Number(summary.amount || 0),
      status,
      createdAt: summary.createdAt || '',
      updatedAt: summary.updatedAt || '',
      orderId: details?.orderId || summary.orderId || '',
      mobileNumber:
        summary.mobileNumber || details?.user?.mobileNumber || details?.mobileNumber || '',
      currency: summary.currency || 'USD',
      applicationStage: '',
      paymentDate: summary.paymentDate || '',
      refundType: summary.refundType || '',
      approvedBy: summary.approvedBy,
      approvedAt: summary.approvedAt,
      amountApproved: summary.amountApproved != null ? Number(summary.amountApproved) : undefined,
      approvalRemarks: summary.approvalRemarks,
      rejectedBy: summary.rejectedBy,
      rejectedAt: summary.rejectedAt,
      rejectionReason: summary.rejectionReason,
      refundAmount: summary.refundAmount != null ? Number(summary.refundAmount) : undefined,
    };
  };

  useEffect(() => {
    setOrderRefund(mapFormDetailsToRefundRequest(formDetails));
  }, [formDetails?.refundSummary, formDetails?.refundStatus, formDetails?.orderId]);

  const normalizeStatus = (status?: string) =>
    String(status || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

  const isGovernmentStatus = (status?: string) =>
    governmentStatusValues.includes(getDocumitraAdminStatusValue(status));

  const getApplicationStatusValue = (status?: string) => {
    const adminStatus = getDocumitraAdminStatusValue(status);
    return isGovernmentStatus(adminStatus) ? 'Application Completed' : adminStatus;
  };

  const getFinalEmailTrackingDetails = (member: any) =>
    member?.finalEmailTrackingDetails || member?.formData?.finalEmailTrackingDetails || {};

  const hasRequiredFinalEmailTrackingDetails = (member: any) =>
    !!String(getFinalEmailTrackingDetails(member)?.trackingId || '').trim() &&
    !!String(getFinalEmailTrackingDetails(member)?.carrierName || '').trim() &&
    !!String(getFinalEmailTrackingDetails(member)?.trackingLink || '').trim();

  const updateMemberTrackingDetailsInState = (memberId: string, values: any) => {
    setMembers((prevMembers: any[]) =>
      prevMembers.map((member: any) =>
        member.id === memberId
          ? {
              ...member,
              finalEmailTrackingDetails: values,
              formData: {
                ...(member?.formData || {}),
                finalEmailTrackingDetails: values,
              },
            }
          : member
      )
    );
  };

  const syncSavedMemberStatuses = (memberList: any[] = []) => {
    const nextStatuses = memberList.reduce((acc: any, member: any) => {
      if (member?.id) {
        acc[member.id] = getDocumitraAdminStatusValue(member?.status || '');
      }
      return acc;
    }, {});
    setSavedMemberStatuses(nextStatuses);
  };

  const isOrderAndPaymentPending = () => {
    const paymentStatus = normalizeStatus(paymentDetails?.paymentDetails?.paymentStatus);
    const fallbackPaymentStatus = normalizeStatus(
      formDetails?.paymentDetails?.paymentStatus || formDetails?.paymentStatus
    );
    const currentPaymentStatus = paymentStatus || fallbackPaymentStatus;
    const applicationStatuses = [
      formDetails?.memberStatus,
      formDetails?.status,
      formDetails?.orderStatus,
      ...((members || []).map((member: any) => member?.status) || []),
    ].map(normalizeStatus);
    const isPrePaymentOrderStatus = applicationStatuses.some(
      status => status === 'order pending' || status === 'payment pending'
    );

    return isPrePaymentOrderStatus && currentPaymentStatus === 'payment pending';
  };

  // Document type selection modal state
  const [docTypeModalPhoto, setDocTypeModalPhoto] = useState<any>(null);
  const [selectedDocCategory, setSelectedDocCategory] = useState<string | undefined>(undefined);
  const [selectedDocType, setSelectedDocType] = useState<string | undefined>(undefined);
  const [docTypeSaving, setDocTypeSaving] = useState<boolean>(false);

  const openDocTypeModal = (photo: any) => {
    setDocTypeModalPhoto(photo);
    setSelectedDocCategory(photo?.documentCategory || undefined);
    setSelectedDocType(photo?.documentType || undefined);
  };

  const closeDocTypeModal = () => {
    setDocTypeModalPhoto(null);
    setSelectedDocCategory(undefined);
    setSelectedDocType(undefined);
  };

  const handleSaveDocumentType = async () => {
    if (!docTypeModalPhoto?.id) return;
    if (!selectedDocCategory) {
      toastError('Please select a document category');
      return;
    }
    if (!selectedDocType) {
      toastError('Please select a document type');
      return;
    }
    try {
      setDocTypeSaving(true);
      const res = await callApi(
        `${DOCUMENT_TYPE_UPDATE}/${formDetails?.id}/${docTypeModalPhoto.id}`,
        'PATCH',
        {
          documentCategory: selectedDocCategory,
          documentType: selectedDocType,
        }
      );

      if (res?.data?.statusCode === 200) {
        toastSuccess('Document type updated');
        const photoId = docTypeModalPhoto.id;
        const updatedMembers = members.map((member: any) => ({
          ...member,
          documents: (member.documents || []).map((doc: any) => ({
            ...doc,
            photos: (doc.photos || []).map((p: any) =>
              p.id === photoId
                ? {
                    ...p,
                    documentCategory: selectedDocCategory,
                    documentType: selectedDocType,
                  }
                : p
            ),
          })),
        }));
        setMembers(updatedMembers);
        closeDocTypeModal();
      } else {
        toastError('Failed to update document type');
      }
    } catch (error) {
      console.error('Error updating document type:', error);
      toastError('Failed to update document type');
    } finally {
      setDocTypeSaving(false);
    }
  };

  const d = new Date();

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const handleAutoCick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };

  const handleDeleteClick = async (memberId: any, docId: any) => {
    // Set loading state for this specific delete operation
    const loadingKey = `${memberId}-${docId}`;
    setDeleteLoadingStates(prev => ({ ...prev, [loadingKey]: true }));

    try {
      if (memberId && docId) {
        console.log('=== DELETE DOCUMENT DEBUG ===');
        console.log('MemberId:', memberId);
        console.log('DocId:', docId);
        console.log('DocId type:', typeof docId);

        // Check if this is a temporary ID (likely a timestamp) or a real database ID
        const isTemporaryId = typeof docId === 'number' && docId > 1000000000000; // Timestamp-based ID
        console.log('Is temporary ID:', isTemporaryId);

        if (isTemporaryId) {
          // This is a temporary ID from local upload, just remove from local state
          console.log('Removing temporary document from local state');

          const updatedMembers = members.map((member: any) => {
            if (member.id === memberId) {
              // If it's a single processed document
              if (member.processedDocument && member.processedDocument.id === docId) {
                return { ...member, processedDocument: null };
              }
              // If it's in processedDocuments array
              if (member.processedDocuments && member.processedDocuments.length > 0) {
                const updatedProcessedDocuments = member.processedDocuments.filter(
                  (doc: any) => doc.id !== docId
                );
                return { ...member, processedDocuments: updatedProcessedDocuments };
              }
            }
            return member;
          });

          setMembers(updatedMembers);
          toastSuccess('Document removed successfully');

          // Update existing PDF status for this member
          const updatedPdfData = await checkExistingPdfForUser(formDetails?.id, memberId);
          if (updatedPdfData) {
            setExistingPdfStatus(prev => ({
              ...prev,
              [memberId]: updatedPdfData,
            }));
          }
        } else {
          // This is a real database ID, call the API to delete from database
          console.log('Calling API to delete document from database');
          console.log('Document ID to delete:', docId);
          console.log('Current members state:', members);

          // Log the specific member and document being deleted
          const targetMember = members.find((member: any) => member.id === memberId);
          console.log('Target member:', targetMember);
          if (targetMember) {
            if (targetMember.processedDocument) {
              console.log('Single processed document:', targetMember.processedDocument);
            }
            if (targetMember.processedDocuments) {
              console.log('Processed documents array:', targetMember.processedDocuments);
            }
          }

          const res = await callApi(`${DOCUMENT_DELETE_SINGLE}/${docId}`, 'DELETE');

          if (res?.data?.statusCode === 200) {
            toastSuccess('Document deleted successfully');

            // Update the specific member's processed documents
            const updatedMembers = members.map((member: any) => {
              if (member.id === memberId) {
                // If it's a single processed document
                if (member.processedDocument && member.processedDocument.id === docId) {
                  return { ...member, processedDocument: null };
                }
                // If it's in processedDocuments array
                if (member.processedDocuments && member.processedDocuments.length > 0) {
                  const updatedProcessedDocuments = member.processedDocuments.filter(
                    (doc: any) => doc.id !== docId
                  );
                  return { ...member, processedDocuments: updatedProcessedDocuments };
                }
              }
              return member;
            });

            setMembers(updatedMembers);
            setLoading(true);

            // Update existing PDF status for this member
            const updatedPdfData = await checkExistingPdfForUser(formDetails?.id, memberId);
            if (updatedPdfData) {
              setExistingPdfStatus(prev => ({
                ...prev,
                [memberId]: updatedPdfData,
              }));
            }

            // Refresh member data from server to ensure complete synchronization
            // Add a small delay to ensure server has processed the delete
            setTimeout(async () => {
              await refreshMemberData();
            }, 500);
          } else {
            console.error('API Response:', res);
            toastError('Failed to delete document from database');

            // Fallback: Try to find the document by name and delete it
            console.log('=== FALLBACK: Trying to find document by name ===');
            const targetMember = members.find((member: any) => member.id === memberId);
            if (targetMember) {
              let documentToDelete = null;

              // Check single processed document
              if (targetMember.processedDocument) {
                documentToDelete = targetMember.processedDocument;
              }
              // Check processed documents array
              else if (
                targetMember.processedDocuments &&
                targetMember.processedDocuments.length > 0
              ) {
                // Find the most recent document (assuming it's the one we want to delete)
                documentToDelete =
                  targetMember.processedDocuments[targetMember.processedDocuments.length - 1];
              }

              if (documentToDelete && documentToDelete.id !== docId) {
                console.log('=== FALLBACK: Found document with different ID ===');
                console.log('Original ID:', docId);
                console.log('Found document ID:', documentToDelete.id);
                console.log('Document name:', documentToDelete.name);

                // Try to delete with the found ID
                try {
                  const fallbackRes = await callApi(
                    `${DOCUMENT_DELETE_SINGLE}/${documentToDelete.id}`,
                    'DELETE'
                  );
                  if (fallbackRes?.data?.statusCode === 200) {
                    toastSuccess('Document deleted successfully (fallback)');
                    // Add a small delay to ensure server has processed the delete
                    setTimeout(async () => {
                      await refreshMemberData();
                    }, 500);
                    return;
                  }
                } catch (fallbackError) {
                  console.error('Fallback delete failed:', fallbackError);
                }
              }
            }
          }
        }
      } else {
        toastError('Invalid member or document ID');
      }
    } catch (error) {
      console.error('Error:', error);
      toastError('An error occurred while deleting the document');
    } finally {
      setDeleteLoadingStates(prev => ({ ...prev, [loadingKey]: false }));
    }
  };

  console.log(userDetails);
  console.log(paymentDetails);
  const onDownload = async (fileUrl: any) => {
    if (fileUrl) {
      window.open(
        fileUrl?.startsWith('https') || !fileUrl ? fileUrl : `${BASE_IMAGE_URL}/${fileUrl}`
      );
    }
  };

  const getDate = (date: string) => {
    const selectedDate = new Date(date);
    const day = selectedDate.getDate();
    const monthName = selectedDate.toLocaleString('default', { month: 'short' });
    const year = selectedDate.getFullYear();

    const formattedDate = `${day}/${monthName}/${year}`;
    return (
      <Text style={{ marginLeft: '25px' }} strong>
        {formattedDate || '--'}
      </Text>
    );
  };

  const getMemberFormData = (member: any, downloadFormButton?: React.ReactNode) => {
    const { formData } = member;
    if (!formData) {
      return <div>No forms available</div>;
    }
    // `formData` may arrive as a JSON string from the API, or as an already
    // parsed object once the component mutates the member in local state
    // (e.g. after the final-email tracking modal saves). Handle both safely.
    let memberForm: any;
    try {
      memberForm = typeof formData === 'string' ? JSON.parse(formData) : formData;
    } catch (e) {
      console.error('Failed to parse member formData:', e);
      return <div>No forms available</div>;
    }
    const { steps } = memberForm || {};
    const NAVY = 'black';

    const PrintField = ({ label, value }: { label: string; value?: React.ReactNode }) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        <span
          style={{
            fontSize: '15px',
            fontWeight: 400,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: '#53657f',
            lineHeight: 1.2,
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#0f172a',
            lineHeight: 1.35,
          }}
        >
          {value || '—'}
        </span>
      </div>
    );

    const orderCardStyle: React.CSSProperties = {
      width: '100%',
      borderRadius: '10px',
      border: '1px solid #e2e8f0',
      background: '#fff',
      padding: '18px 20px',
      marginBottom: '18px',
    };

    const sectionTitleStyle: React.CSSProperties = {
      fontSize: '16px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',

      color: NAVY,
      marginBottom: '12px',
      paddingBottom: '10px',
      borderBottom: '1px solid #e2e8f0',
      lineHeight: 1.2,
    };

    const fieldGridStyle: React.CSSProperties = {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      columnGap: '28px',

      rowGap: '14px',
    };

    const stepCardStyle: React.CSSProperties = {
      width: '100%',
      borderRadius: '10px',
      border: '1px solid #e2e8f0',
      background: '#fff',
      padding: '18px 20px',
      marginBottom: '14px',
    };

    const stepHeaderStyle: React.CSSProperties = {
      fontSize: '15px',
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: NAVY,
      marginBottom: '14px',
      paddingBottom: '10px',
      lineHeight: 1.2,
    };

    const qaRowStyle: React.CSSProperties = {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '10px 0',
      borderBottom: '1px solid #f1f5f9',
      alignItems: 'flex-start',
    };

    const qaLabelStyle: React.CSSProperties = {
      fontSize: '16px',
      fontWeight: 400,
      color: '#475569',
      lineHeight: 1.5,
      paddingTop: '2px',
    };

    const qaValueStyle: React.CSSProperties = {
      fontSize: '15px',
      fontWeight: 600,
      color: '#0f172a',
      lineHeight: 1.5,
    };

    const imageWrapStyle: React.CSSProperties = {
      display: 'inline-flex',
      position: 'relative',
      borderRadius: '6px',
      overflow: 'hidden',
      border: '1px solid #e2e8f0',
    };

    const hasTopFields =
      formDetails?.applyingFrom ||
      formDetails?.citizenship ||
      formDetails?.destination ||
      formDetails?.serviceId;

    return (
      <>
        <div style={orderCardStyle}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px',

              paddingBottom: '10px',
              borderBottom: '1px solid #e2e8f0',
            }}
          >
            <div
              style={{
                fontSize: '16px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                color: NAVY,
                lineHeight: 1.2,
              }}
            >
              Order &amp; Member Information
            </div>
            {downloadFormButton}
          </div>
          <div style={fieldGridStyle}>
            <PrintField label="Order ID" value={formDetails?.orderId} />
            <PrintField label="Member Name" value={member?.name} />
            <PrintField label="Age Group" value={member?.ageGroup} />
            <PrintField label="Package Name" value={paymentDetails?.packageName} />
          </div>
          {hasTopFields && (
            <>
              <div
                style={{
                  marginTop: '16px',
                  paddingTop: '16px',
                  borderTop: '1px dashed #cbd5e1',
                }}
              />
              <div style={fieldGridStyle}>
                {formDetails?.applyingFrom && (
                  <PrintField label="Applying From" value={formDetails?.applyingFrom} />
                )}
                {formDetails?.citizenship && (
                  <PrintField label="Citizenship" value={formDetails?.citizenship} />
                )}
                {formDetails?.destination && (
                  <PrintField label="Destination" value={formDetails?.destination} />
                )}
                {formDetails?.serviceId && <PrintField label="Service Name" value={serviceName} />}
              </div>
            </>
          )}
        </div>

        {steps?.map((step: any, stepIdx: number) => {
          const questions = step?.stepQuestions || [];

          return (
            <div key={step?.id} style={{ width: '100%', marginBottom: '18px', padding: '0 20px' }}>
              <div style={stepHeaderStyle}>
                {String(stepIdx + 1).padStart(2, '0')}. {step?.stepTitle}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {questions?.map((question: any, qIdx: number) => (
                  <div
                    key={question?.id}
                    style={{
                      ...qaRowStyle,
                      borderBottom:
                        qIdx === (questions?.length || 0) - 1 ? 'none' : '1px solid #f1f5f9',
                    }}
                  >
                    <div style={qaLabelStyle}>
                      <span style={{ color: NAVY }}>Q</span> {question?.question?.label}
                    </div>
                    <div>
                      {/* eslint-disable-next-line no-nested-ternary */}
                      {question?.question?.inputType === 'file upload' ||
                      question?.question?.inputType === 'image upload' ? (
                        <div style={imageWrapStyle}>
                          <Image
                            width={200}
                            src={
                              question?.question?.value?.url?.startsWith('https') ||
                              !question?.question?.value?.url
                                ? question?.question?.value?.url
                                : `${BASE_IMAGE_URL}/${question?.question?.value?.url}`
                            }
                            fallback={fallback}
                          />
                          <DownloadOutlined
                            style={{
                              position: 'absolute',
                              fontSize: 16,
                              bottom: '8px',
                              right: '8px',
                              padding: '4px',
                              cursor: 'pointer',
                              backgroundColor: 'rgba(0, 0, 0, 0.60)',
                              borderRadius: '4px',
                              color: 'white',
                            }}
                            onClick={() => onDownload(question?.question?.value?.url)}
                          />
                        </div>
                      ) : question?.question?.inputType === 'date' ? (
                        <span style={qaValueStyle}>
                          {(() => {
                            const d = question?.question?.value;
                            if (!d) return '—';
                            const sd = new Date(d);
                            const day = sd.getDate();
                            const monthName = sd.toLocaleString('default', { month: 'short' });
                            const year = sd.getFullYear();
                            return `${day}/${monthName}/${year}`;
                          })()}
                        </span>
                      ) : (
                        <span style={qaValueStyle}>{question?.question?.value || '—'}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const handleAddRemarks = (doc: any, photo: any) => () => {
    const docName =
      doc?.name ||
      doc?.documentName ||
      doc?.title ||
      doc?.documentCategory ||
      photo?.documentType ||
      photo?.documentCategory ||
      '';
    const presets = Array.isArray(doc?.remarkPresets)
      ? doc.remarkPresets.filter((r: any) => typeof r === 'string' && r.trim())
      : [];
    setActiveDocName(docName);
    setActiveRemarkPresets(presets);
    setActivePhoto(photo);
    setOpenAddRemarks(!openAddRemark);
  };

  const handleRemarkUpdate = (updatedPhoto: any) => {
    // Update the members state with the updated photo remark
    const updatedMembers = members.map((member: any) => {
      if (member.documents) {
        const updatedDocuments = member.documents.map((doc: any) => {
          if (doc.photos) {
            const updatedPhotos = doc.photos.map((photo: any) => {
              if (photo.id === updatedPhoto.id) {
                return { ...photo, remark: updatedPhoto.remark };
              }
              return photo;
            });
            return { ...doc, photos: updatedPhotos };
          }
          return doc;
        });
        return { ...member, documents: updatedDocuments };
      }

      // Also update processedDocument if it's the one that was updated
      if (member.processedDocument && member.processedDocument.id === updatedPhoto.id) {
        return {
          ...member,
          processedDocument: { ...member.processedDocument, remark: updatedPhoto.remark },
        };
      }

      return member;
    });

    setMembers(updatedMembers);
  };

  const handleMemberStatusUpdate = async (
    memberId: string,
    newStatus: string,
    remark?: string,
    paymentDetailsForEmail?: { paymentAmount?: string; paymentFor?: string }
  ) => {
    try {
      // Set loading state for this specific member
      setMemberStatusLoadingStates(prev => ({ ...prev, [memberId]: true }));

      console.log('Updating member status:', { memberId, newStatus });

      const response = await callApi(
        `application/admin-order/${formDetails?.id}/member-status`, // Admin endpoint for CMS
        'PATCH',
        {
          memberId: memberId,
          status: newStatus,
          // Remark is stored with government statuses (required for "Application Rejected by Authority")
          ...(remark !== undefined ? { remark } : {}),
          // Government fee amount / type go into the "Government fee payment pending" email
          ...(paymentDetailsForEmail?.paymentAmount
            ? { paymentAmount: paymentDetailsForEmail.paymentAmount }
            : {}),
          ...(paymentDetailsForEmail?.paymentFor
            ? { paymentFor: paymentDetailsForEmail.paymentFor }
            : {}),
        }
      );

      console.log('Member status update response:', response);

      if (response?.status === true || response?.data?.statusCode === 200) {
        const savedMember = response?.data?.data || {};
        // "Application Rejected by Authority" is applied as a tag and the backend moves the
        // application status to "Fill Form"; always trust the saved member.
        const effectiveStatus = savedMember?.status || newStatus;
        const savedRemark =
          savedMember?.governmentStatusRemark !== undefined
            ? savedMember.governmentStatusRemark
            : remark;
        setMembers((prevMembers: any[]) =>
          prevMembers.map((member: any) =>
            member.id === memberId
              ? {
                  ...member,
                  status: effectiveStatus,
                  ...(savedMember?.isRejectedByAuthority !== undefined
                    ? { isRejectedByAuthority: savedMember.isRejectedByAuthority }
                    : {}),
                  ...(savedRemark !== undefined ? { governmentStatusRemark: savedRemark } : {}),
                }
              : member
          )
        );
        setSavedMemberStatuses(prev => ({
          ...prev,
          [memberId]: getDocumitraAdminStatusValue(effectiveStatus),
        }));
        setGovernmentRemarkDrafts(prev => {
          const next = { ...prev };
          delete next[memberId];
          return next;
        });
        setRejectionOutcomeDrafts(prev => {
          const next = { ...prev };
          delete next[memberId];
          return next;
        });
        toastSuccess(
          isDocumitraRejectedByAuthorityStatus(newStatus)
            ? 'Tagged "Rejected by Authority". Application status moved to Fill Form.'
            : getDocumitraAdminStatusValue(newStatus) === 'Withdrawal by applicant'
              ? 'Government status updated to Withdrawal by applicant.'
              : 'Application status updated successfully'
        );
      } else {
        console.error('Failed to update member status:', response);
        toastError('Failed to update member status');
      }
    } catch (error) {
      console.error('Error updating member status:', error);
      toastError('Failed to update member status');
    } finally {
      // Clear loading state
      setMemberStatusLoadingStates(prev => ({ ...prev, [memberId]: false }));
    }
  };

  const handleMemberHoldUpdate = async (member: any, onHold: boolean, remark?: string) => {
    if (!formDetails?.id || !member?.id) {
      toastError('Order or member details missing');
      return;
    }
    try {
      setHoldSaving(true);
      const response = await callApi(
        `application/admin-order/${formDetails.id}/member-hold`,
        'PATCH',
        { memberId: member.id, onHold, remark: onHold ? remark?.trim() || undefined : undefined }
      );
      if (response?.status === true || response?.data?.statusCode === 200) {
        const savedMember = response?.data?.data || {};
        setMembers((prevMembers: any[]) =>
          prevMembers.map((m: any) =>
            m.id === member.id
              ? {
                  ...m,
                  isOnHold: savedMember?.isOnHold ?? onHold,
                  onHoldRemark: savedMember?.onHoldRemark ?? (onHold ? remark || null : null),
                }
              : m
          )
        );
        setHoldModal({ open: false });
        setHoldRemark('');
        toastSuccess(onHold ? 'Application put on hold' : 'Hold released');
      } else {
        toastError(response?.data?.message || 'Failed to update hold');
      }
    } catch (error) {
      console.error('Error updating hold:', error);
      toastError('Failed to update hold');
    } finally {
      setHoldSaving(false);
    }
  };

  const openTrackingDetailsModal = (member: any, status: string) => {
    const finalEmailTrackingDetails = getFinalEmailTrackingDetails(member);
    trackingDetailsForm.setFieldsValue({
      trackingId: finalEmailTrackingDetails?.trackingId || '',
      carrierName: finalEmailTrackingDetails?.carrierName || '',
      trackingLink: finalEmailTrackingDetails?.trackingLink || '',
    });
    setTrackingDetailsModal({ open: true, member, status });
  };

  const handleApplicationStatusUpdate = (member: any) => {
    const rawStatusToUpdate =
      member?.status || formDetails?.memberStatus || formDetails?.status || 'Fill Form';
    const statusToUpdate = getApplicationStatusValue(rawStatusToUpdate);

    // "Government Fee payment pending" emails the amount + fee type entered below the status
    if (statusToUpdate === GOVERNMENT_FEE_PENDING_STATUS) {
      const feeDraft = governmentFeeDrafts[member.id];
      if (!feeDraft?.paymentAmount?.trim()) {
        toastError('Please enter the government fee amount to include in the applicant email');
        return;
      }
      handleMemberStatusUpdate(member.id, statusToUpdate, undefined, {
        paymentAmount: feeDraft.paymentAmount.trim(),
        paymentFor: feeDraft.paymentFor || GOVERNMENT_FEE_PAYMENT_FOR_OPTIONS[0],
      });
      return;
    }

    handleMemberStatusUpdate(member.id, statusToUpdate);
  };

  const submitTrackingDetailsAndStatus = async () => {
    try {
      const values = await trackingDetailsForm.validateFields();
      const member = trackingDetailsModal.member;
      const status = trackingDetailsModal.status || FINAL_EMAIL_STATUS;

      if (!member?.id) {
        toastError('Member details missing');
        return;
      }

      setTrackingDetailsSaving(true);

      const payload = {
        finalEmailTrackingDetails: {
          trackingId: values.trackingId,
          carrierName: values.carrierName,
          trackingLink: values.trackingLink,
        },
      };

      const res = await callApi(
        `${DOCUMENT_USER_ADDITIONAL_DETAILS}/${member.id}`,
        'PATCH',
        payload
      );

      if (res?.data?.statusCode === 200) {
        updateMemberTrackingDetailsInState(member.id, payload.finalEmailTrackingDetails);
        setTrackingDetailsModal({ open: false });
        trackingDetailsForm.resetFields();
        await handleMemberStatusUpdate(member.id, status);
      } else {
        toastError('Failed to update tracking details');
      }
    } catch (error: any) {
      if (error?.errorFields) {
        return;
      }
      console.error('Error updating tracking details:', error);
      toastError('Failed to update tracking details');
    } finally {
      setTrackingDetailsSaving(false);
    }
  };

  const handlePaymentStatusUpdate = async (newPaymentStatus: string) => {
    if (!formDetails?.id) {
      toastError('Order id missing — cannot update payment status');
      return;
    }
    if (!newPaymentStatus || !String(newPaymentStatus).trim()) {
      toastError('Please select a payment status');
      return;
    }
    try {
      setPaymentStatusLoading(true);

      const response = await callApi(`application/admin-order/${formDetails.id}`, 'PATCH', {
        paymentDetails: {
          paymentStatus: newPaymentStatus,
        },
      });

      const payload = response?.data;
      const ok =
        response?.status === true ||
        payload?.statusCode === 200 ||
        payload?.isSuccess === 1 ||
        payload?.isSuccess === '1';

      if (ok) {
        const updatedFormDetails = {
          ...formDetails,
          paymentDetails: {
            ...formDetails?.paymentDetails,
            paymentStatus: newPaymentStatus,
          },
        };

        setPaymentDetails((prev: any) => ({
          ...prev,
          paymentDetails: {
            ...(prev?.paymentDetails || formDetails?.paymentDetails || {}),
            paymentStatus: newPaymentStatus,
          },
        }));

        if (props.additionalData?.onUpdate) {
          props.additionalData.onUpdate(updatedFormDetails);
        }

        if (props.additionalData?.onSuccessfulUpdate) {
          setTimeout(() => {
            props.additionalData.onSuccessfulUpdate();
          }, 200);
        }

        toastSuccess('Payment status updated successfully');
      } else {
        const errMsg =
          typeof payload?.message === 'string'
            ? payload.message
            : payload?.message != null
              ? JSON.stringify(payload.message)
              : 'Failed to update payment status';
        toastError(errMsg);
      }
    } catch (error: any) {
      console.error('Error updating payment status:', error);
      toastError('Failed to update payment status');
    } finally {
      setPaymentStatusLoading(false);
    }
  };

  const handleDownloadAll = async (items: any) => {
    try {
      setDownloadLoading(true);
      console.log('=== DEBUG: handleDownloadAll called ===');
      console.log('Items data:', items);
      console.log('Items type:', typeof items);
      console.log('Items keys:', Object.keys(items || {}));

      // Check if items has the expected structure
      if (!items || !items.documents) {
        console.error('Items does not have documents property:', items);
        toastError('Invalid data structure. Please try again.');
        return;
      }

      console.log('Documents array:', items.documents);
      console.log('Documents length:', items.documents.length);

      // Collect all URLs and their metadata
      const allUrls: any = [];
      items.documents.forEach((doc: any, docIndex: number) => {
        console.log(`Document ${docIndex}:`, doc);
        console.log(`Document name: ${doc.name}`);
        console.log(`Document photos:`, doc.photos);

        if (doc.photos && doc.photos.length > 0) {
          // Include ALL documents (approved, pending, and rejected) for download all
          const allPhotos = doc.photos;
          console.log(
            `Document ${doc.name}: Total photos: ${doc.photos.length}, All photos included: ${allPhotos.length}`
          );

          console.log(
            `Document ${doc.name}: Total photos: ${doc.photos.length}, All photos included: ${allPhotos.length}`
          );
          console.log(
            'Photo approval statuses:',
            doc.photos.map((p: any) => ({ id: p.id, approved_status: p.approved_status }))
          );

          allPhotos.forEach((photo: any, photoIndex: number) => {
            console.log(`Photo ${photoIndex}:`, photo);
            console.log(`Photo URL: ${photo.url}`);

            if (photo.url) {
              // Normalize the URL - if it's a relative URL, convert it to full URL
              let normalizedUrl = photo.url;
              if (!photo.url.startsWith('http://') && !photo.url.startsWith('https://')) {
                // If it's a relative URL, construct the full URL using BASE_IMAGE_URL
                normalizedUrl = photo.url.startsWith('/') ? photo.url.substring(1) : photo.url;
                // Remove any extra slashes and normalize the URL
                normalizedUrl = normalizedUrl.replace(/^\/+/, '').replace(/\/+/g, '/');
                normalizedUrl = `${BASE_IMAGE_URL}/${normalizedUrl}`;
              }

              // Extract the actual file name from the URL
              const urlParts = photo.url.split('/');
              const fileName = urlParts[urlParts.length - 1];
              // Remove any query parameters and get the base filename
              const cleanFileName = fileName.split('?')[0];
              // Decode URL-encoded characters to get the actual file name
              const decodedFileName = decodeURIComponent(cleanFileName);
              // Replace + signs with spaces to get the original file name
              const actualFileName = decodedFileName.replace(/\+/g, ' ');

              console.log(`Normalized URL: ${normalizedUrl}`);
              console.log(`Actual file name: ${actualFileName}`);

              allUrls.push({
                url: normalizedUrl,
                docName: doc.name,
                fileName: actualFileName,
                index: photoIndex + 1,
                photoId: photo.id,
              });
            } else {
              console.warn(`Photo ${photoIndex} has no URL:`, photo);
            }
          });
        } else {
          console.warn(`Document ${doc.name} has no photos`);
        }
      });

      console.log('All URLs to download:', allUrls);
      console.log('Total URLs found:', allUrls.length);

      if (allUrls.length === 0) {
        toastError('No approved documents found to download');
        return;
      }

      // Use backend endpoint to handle file downloads and zip creation
      try {
        const response = await fetch(`${BASE_API_URL}/application/download-all-documents`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getToken(),
          },
          body: JSON.stringify({
            memberId: items.id,
            documents: allUrls.map((item: any) => ({
              url: item.url,
              docName: item.docName,
              fileName: item.fileName,
              index: item.index,
              photoId: item.photoId,
            })),
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        console.log('Downloaded zip blob size:', blob.size);

        if (blob.size === 0) {
          toastError('No files were successfully downloaded. Please try again.');
          return;
        }

        const zipUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = `all-documents-${items.id || 'member'}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(zipUrl);

        toastSuccess(`All documents downloaded as ZIP file (${allUrls.length} files)`);
      } catch (error) {
        console.error('Error downloading zip from backend:', error);
        toastError('Failed to download documents. Please try again.');
      }
    } catch (error) {
      console.error('Error creating zip file:', error);
      toastError('Failed to create zip file. Please try again.');
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleDownloadAcceptedDocuments = async (member: any) => {
    try {
      setDownloadLoading(true);

      if (!member?.documents || member.documents.length === 0) {
        toastError('No accepted documents found to download');
        return;
      }

      const acceptedDocuments = member.documents.flatMap((doc: any) =>
        (doc?.photos || [])
          .filter(
            (photo: any) => photo?.approved_status === true && !photo?.is_duplicate && photo?.url
          )
          .map((photo: any, photoIndex: number) => {
            const fileName = decodeURIComponent(
              photo.url.split('/').pop()?.split('?')[0] || `document-${photoIndex + 1}`
            ).replace(/\+/g, ' ');
            const normalizedUrl =
              photo.url.startsWith('http://') || photo.url.startsWith('https://')
                ? photo.url
                : `${BASE_IMAGE_URL}/${photo.url.replace(/^\/+/, '').replace(/\/+/g, '/')}`;

            return {
              url: normalizedUrl,
              docName: doc.name,
              fileName,
              index: photoIndex + 1,
              photoId: photo.id,
            };
          })
      );

      if (acceptedDocuments.length === 0) {
        toastError('No accepted documents found to download');
        return;
      }

      const response = await fetch(`${BASE_API_URL}/application/download-all-documents`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify({
          memberId: member.id,
          documents: acceptedDocuments,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      if (blob.size === 0) {
        toastError('No accepted documents were successfully downloaded. Please try again.');
        return;
      }

      const zipUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = zipUrl;
      link.download = `accepted-documents-${member.id || 'member'}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(zipUrl);

      toastSuccess(`Accepted documents downloaded as ZIP file (${acceptedDocuments.length} files)`);
    } catch (error) {
      console.error('Error downloading accepted documents:', error);
      toastError('Failed to download accepted documents. Please try again.');
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleDownloadAllCombined = async (member: any) => {
    try {
      setCombinedPdfLoading(true);
      console.log('=== DEBUG: handleDownloadAllCombined called ===');
      console.log('Member data:', member);

      if (!member?.documents || member.documents.length === 0) {
        toastError('No documents found to combine');
        return;
      }

      // Collect all documents with their data for combined PDFs, excluding rejected documents
      const documentsToCombine = member.documents
        .filter((doc: any) => doc.photos && doc.photos.length > 0)
        .map((doc: any) => {
          console.log(`=== FRONTEND: Processing document ${doc.name} for combined download ===`);
          console.log(`Document ${doc.name}: Total photos: ${doc.photos.length}`);
          console.log(
            'Photo approval statuses:',
            doc.photos.map((p: any) => ({ id: p.id, approved_status: p.approved_status }))
          );

          const documentsWithFileNames = doc.photos
            .filter((photo: any) => {
              // Log each photo's approval status for debugging
              console.log(
                `Photo ${photo.id}: approved_status = ${photo?.approved_status}, type = ${typeof photo?.approved_status}`
              );

              // Exclude if explicitly rejected (false) or marked as duplicate
              const isRejected = photo?.approved_status === false || !!photo?.is_duplicate;
              console.log(`Photo ${photo.id}: isRejected/duplicate = ${isRejected}`);

              // Include if not rejected (approved or pending)
              const shouldInclude = !isRejected;
              console.log(`Photo ${photo.id}: shouldInclude = ${shouldInclude}`);

              return shouldInclude;
            })
            .map((photo: any) => {
              // Extract the original file name from the URL
              const urlParts = photo.url.split('/');
              const fileName = urlParts[urlParts.length - 1];
              // Remove any query parameters and get the base filename
              const cleanFileName = fileName.split('?')[0];
              // Decode URL-encoded characters to get the actual file name
              const decodedFileName = decodeURIComponent(cleanFileName);
              // Replace + signs with spaces to get the original file name
              const finalFileName = decodedFileName.replace(/\+/g, ' ');

              return {
                url: photo.url,
                fileName: finalFileName,
                photoId: photo.id,
              };
            });

          return {
            documentId: doc.id,
            documentName: doc.name,
            documents: documentsWithFileNames,
          };
        });

      console.log(
        'Documents to combine:',
        documentsToCombine.map((d: any) => ({
          documentName: d.documentName,
          documentCount: d.documents.length,
          documents: d.documents.map((doc: any) => ({
            fileName: doc.fileName,
            photoId: doc.photoId,
          })),
        }))
      );

      // Filter out document types that have no approved documents
      const documentsToCombineFiltered = documentsToCombine.filter(
        (doc: any) => doc.documents.length > 0
      );

      console.log(
        'Documents to combine (filtered):',
        documentsToCombineFiltered.map((d: any) => ({
          documentName: d.documentName,
          documentCount: d.documents.length,
        }))
      );

      if (documentsToCombineFiltered.length === 0) {
        toastError('No approved documents found to combine');
        return;
      }

      if (documentsToCombine.length === 0) {
        toastError('No documents found to combine');
        return;
      }

      // Use backend endpoint to create combined PDFs and zip them
      const response = await fetch(`${BASE_API_URL}/pdf/merge-all-combined`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify({
          memberId: member.id,
          documents: documentsToCombineFiltered,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      console.log('Downloaded zip blob size:', blob.size);

      if (blob.size === 0) {
        toastError('No files were successfully created. Please try again.');
        return;
      }

      const zipUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = zipUrl;
      link.download = `all_combined_documents_${member.id || 'member'}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(zipUrl);

      toastSuccess(
        `All combined documents downloaded as ZIP file (${documentsToCombine.length} sections)`
      );
    } catch (error) {
      console.error('Error creating combined PDFs zip:', error);
      toastError('Failed to create combined PDFs. Please try again.');
    } finally {
      setCombinedPdfLoading(false);
    }
  };

  const getFileExtension = (url: string) => {
    const parts = url.split('.');
    return parts[parts.length - 1].toLowerCase();
  };

  const documentAcceptRejectClick = async (access: any, id: any) => {
    const photoId = String(id);
    if (documentActionsInFlight.current.has(photoId)) return;

    const currentPhoto = members
      .flatMap((member: any) => member?.documents || [])
      .flatMap((doc: any) => doc?.photos || [])
      .find((photo: any) => String(photo?.id) === photoId);
    if (currentPhoto?.approved_status === access && !currentPhoto?.is_duplicate) {
      return;
    }

    documentActionsInFlight.current.add(photoId);
    setDocumentActionLoadingStates(previous => ({ ...previous, [photoId]: true }));
    try {
      const payload = { approved_status: access };
      console.log(`=== FRONTEND: Document ${access ? 'accept' : 'reject'} ===`);
      console.log('Document ID:', id);
      console.log('Payload:', payload);

      const res = await callApi(
        `${DOCUMENT_ACCEPT_REJECT}/${formDetails?.id}/${id}`,
        'PATCH',
        payload
      );

      console.log('Response:', res);

      if (res?.data?.statusCode === 200 || res?.status === true) {
        if (payload.approved_status === true) {
          toastSuccess('Document Accepted');
        } else {
          toastError('Document Rejected');
        }

        setMembers((previousMembers: any[]) =>
          previousMembers.map((member: any) => ({
            ...member,
            documents: (member.documents || []).map((doc: any) => ({
              ...doc,
              photos: (doc.photos || []).map((photo: any) =>
                String(photo?.id) === photoId
                  ? { ...photo, approved_status: access, is_duplicate: false }
                  : photo
              ),
            })),
          }))
        );
      } else {
        toastError(res?.data?.message || 'Failed to update document status');
      }
    } catch (error) {
      console.error('Error:', error);
      toastError('Failed to update document status');
    } finally {
      documentActionsInFlight.current.delete(photoId);
      setDocumentActionLoadingStates(previous => ({ ...previous, [photoId]: false }));
    }
  };

  // Mark / unmark an individual upload as a duplicate (same flow as Accept / Reject).
  // A duplicate is neither accepted nor rejected and is skipped by merges / accepted downloads.
  const documentDuplicateClick = async (isDuplicate: boolean, id: any) => {
    try {
      const res = await callApi(`${DOCUMENT_MARK_DUPLICATE}/${formDetails?.id}/${id}`, 'PATCH', {
        is_duplicate: isDuplicate,
      });

      if (res?.data?.statusCode === 200) {
        if (isDuplicate) {
          toastWarning('Document marked as duplicate');
        } else {
          toastSuccess('Duplicate mark removed');
        }

        setMembers((prevMembers: any[]) =>
          prevMembers.map((member: any) => ({
            ...member,
            documents: (member.documents || []).map((doc: any) => ({
              ...doc,
              photos: (doc.photos || []).map((photo: any) =>
                photo.id === id
                  ? {
                      ...photo,
                      is_duplicate: isDuplicate,
                      approved_status: isDuplicate ? null : photo.approved_status,
                    }
                  : photo
              ),
            })),
          }))
        );
      } else {
        toastError(res?.data?.message || 'Failed to update duplicate mark');
      }
    } catch (error) {
      console.error('Error marking duplicate:', error);
      toastError('Failed to update duplicate mark');
    }
  };

  const [presignedContent, setPresignedContent] = useState<PresignedContent[]>([]);
  const handlePresignedUrl = async (photo: any) => {
    try {
      const result = await callApi(`/s3/presigned-url/${photo?.url}`, 'GET');
      console.log('handlePresignedUrl', photo);

      if (result && result.data) {
        return { id: photo?.id, data: result?.data?.data };
      } else {
        console.error('Received an invalid result:', result);
        return null; // Return null if the result is invalid
      }
    } catch (error) {
      console.error('Error fetching presigned URL:', error);
      return null; // Return null if there's an error
    }
  };

  console.log('presignedContent', presignedContent);
  const escapeHtml = (value: any) =>
    String(value ?? '--')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const formatDate = (dateVal: any) => {
    if (!dateVal) return '—';
    const sd = new Date(dateVal);
    const day = sd.getDate();
    const monthName = sd.toLocaleString('default', { month: 'short' });
    const year = sd.getFullYear();
    return `${day}/${monthName}/${year}`;
  };

  const getImageUrl = (url: any) => {
    if (!url || url.startsWith('https')) return url || '';
    return `${BASE_IMAGE_URL}/${url}`;
  };

  const renderQaValue = (question: any) => {
    const inputType = question?.question?.inputType;
    if (inputType === 'file upload' || inputType === 'image upload') {
      const imgUrl = getImageUrl(question?.question?.value?.url);
      if (!imgUrl) return '—';
      return `<img src="${escapeHtml(imgUrl)}" style="max-width: 220px; max-height: 200px; border-radius: 4px; display: block;" />`;
    }
    if (inputType === 'date') {
      return escapeHtml(formatDate(question?.question?.value));
    }
    return escapeHtml(question?.question?.value || '—');
  };

  const handleDownloadForm = (member: any) => {
    const { formData } = member;
    if (!formData) {
      return;
    }
    let memberForm: any;
    try {
      memberForm = typeof formData === 'string' ? JSON.parse(formData) : formData;
    } catch (e) {
      console.error('Failed to parse member formData:', e);
      return;
    }
    const { steps } = memberForm || {};
    const NAVY = 'black';

    const hasTopFields =
      formDetails?.applyingFrom ||
      formDetails?.citizenship ||
      formDetails?.destination ||
      formDetails?.serviceId;

    const printWindow = window.open('', '_blank');

    if (printWindow) {
      printWindow.document.write(`<html><head><title>Form Details</title>
        <style>
          @page { size: A4; margin: 15mm 12mm; }
          body { margin: 0; padding: 0; font-family: Inter, sans-serif; background: #fff; color: #0f172a; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          * { box-sizing: border-box; }
          .print-template { width: 100%; }
          .order-section { width: 100%; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; padding: 18px 20px; margin-bottom: 18px; page-break-inside: avoid; }
          .section-title { font-size: 16px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: ${NAVY}; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0; line-height: 1.2; }
          .field-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); column-gap: 28px; row-gap: 14px; }
          .print-field { display: flex; flex-direction: column; gap: 3px; }
          .print-field-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: #53657f; line-height: 1.2; }
          .print-field-value { font-size: 14px; font-weight: 700; color: ${NAVY}; line-height: 1.35; word-break: break-word; }
          .dashed-divider { margin-top: 16px; padding-top: 16px; border-top: 1px dashed #cbd5e1; }
          .step-section { width: 100%; background: #fff; margin-bottom: 18px; page-break-inside: avoid; }
          .step-header { font-size: 15px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: ${NAVY}; margin-bottom: 14px; padding-bottom: 10px; line-height: 1.2; }
          .qa-row { display: flex; flex-direction: column; gap: 4px; padding: 10px 0; border-bottom: 1px solid #f1f5f9; align-items: flex-start; }
          .qa-row:last-child { border-bottom: none; }
          .qa-q-prefix { color: ${NAVY}; font-weight: 600; }
          .qa-label { font-size: 12px; font-weight: 500; color: #475569; line-height: 1.5; padding-top: 2px; word-break: break-word; }
          .qa-value { font-size: 12px; font-weight: 600; color: #0f172a; line-height: 1.5; word-break: break-word; }
          .qa-value img { page-break-inside: avoid; }
        </style>
        </head>
        <body>
        <div class="print-template">`);

      printWindow.document.write(`
        <div class="order-section">
          <div class="section-title">Order &amp; Member Information</div>
          <div class="field-grid">
            <div class="print-field"><span class="print-field-label">Order ID</span><span class="print-field-value">${escapeHtml(formDetails?.orderId || '—')}</span></div>
            <div class="print-field"><span class="print-field-label">Member Name</span><span class="print-field-value">${escapeHtml(member?.name || '—')}</span></div>
            <div class="print-field"><span class="print-field-label">Age Group</span><span class="print-field-value">${escapeHtml(member?.ageGroup || '—')}</span></div>
            <div class="print-field"><span class="print-field-label">Package Name</span><span class="print-field-value">${escapeHtml(paymentDetails?.packageName || '—')}</span></div>
          </div>
          ${
            hasTopFields
              ? `
            <div class="dashed-divider"></div>
            <div class="field-grid">
              ${formDetails?.applyingFrom ? `<div class="print-field"><span class="print-field-label">Applying From</span><span class="print-field-value">${escapeHtml(formDetails.applyingFrom)}</span></div>` : ''}
              ${formDetails?.citizenship ? `<div class="print-field"><span class="print-field-label">Citizenship</span><span class="print-field-value">${escapeHtml(formDetails.citizenship)}</span></div>` : ''}
              ${formDetails?.destination ? `<div class="print-field"><span class="print-field-label">Destination</span><span class="print-field-value">${escapeHtml(formDetails.destination)}</span></div>` : ''}
              ${formDetails?.serviceId ? `<div class="print-field"><span class="print-field-label">Service Name</span><span class="print-field-value">${escapeHtml(serviceName || '—')}</span></div>` : ''}
            </div>
          `
              : ''
          }
        </div>
      `);

      (steps || []).forEach((step: any, stepIdx: number) => {
        const questions = step?.stepQuestions || [];

        const qaRows = questions
          .map((question: any, qIdx: number) => {
            const isLast = qIdx === questions.length - 1;
            return `
              <div class="qa-row" style="${isLast ? 'border-bottom: none;' : ''}">
                <div class="qa-label"><span class="qa-q-prefix">Q</span> ${escapeHtml(question?.question?.label || '—')}</div>
                <div class="qa-value">${renderQaValue(question)}</div>
              </div>
            `;
          })
          .join('');

        printWindow.document.write(`
          <div class="step-section">
            <div class="step-header">${String(stepIdx + 1).padStart(2, '0')}. ${escapeHtml(step?.stepTitle || '')}</div>
            <div>${qaRows}</div>
          </div>
        `);
      });

      printWindow.document.write(`
        </div>
        </body>
        </html>
      `);

      printWindow.document.close();
      setTimeout(() => {
        printWindow.print();
      }, 400);
    }
  };

  const getMemberDocumentsData = (member: any) => {
    // Separate documents into those with photos and those without
    const documentsWithPhotos =
      member?.documents?.filter((doc: any) => doc?.photos?.length > 0) || [];
    const documentsWithoutPhotos =
      member?.documents?.filter((doc: any) => !doc?.photos || doc?.photos?.length === 0) || [];

    return (
      <div>
        {memberHasDocuments(member) && (
          <div
            style={{
              width: '100%',
              padding: '20px',
              border: '1px solid rgb(226, 232, 240)',
              borderRadius: '8px',
            }}
          >
            {/* Documents with photos - grouped by category */}
            {documentsWithPhotos.length > 0 && (
              <div style={{ marginBottom: '30px' }}>
                {documentsWithPhotos.map((doc: any) => (
                  <div key={doc?.id} style={{ marginBottom: '25px' }}>
                    {/* Category Header with Merge Button */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '30px',
                        marginBottom: '12px',
                        paddingBottom: '8px',
                      }}
                    >
                      <Title
                        level={5}
                        style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: 'black' }}
                      >
                        {doc?.name}
                      </Title>
                      <Button
                        type="primary"
                        size="small"
                        icon={
                          mergeLoadingStates[`${member.id}-${doc.id}`] ? (
                            <Spin size="small" />
                          ) : (
                            <DownloadOutlined />
                          )
                        }
                        onClick={() => handleMergeDocumentsByType(member.id, doc.id, doc)}
                        style={{
                          backgroundColor: '#28a745',
                          color: 'white',
                          borderRadius: '4px',
                          padding: '4px 12px',
                          fontSize: '13px',
                          height: '32px',
                          border: 'none',
                          fontWeight: 600,
                        }}
                        loading={mergeLoadingStates[`${member.id}-${doc.id}`]}
                        disabled={mergeLoadingStates[`${member.id}-${doc.id}`]}
                      >
                        {mergeLoadingStates[`${member.id}-${doc.id}`]
                          ? 'Merging...'
                          : 'Download Combined PDF'}
                      </Button>
                    </div>

                    {/* Document Cards Grid */}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '12px',
                      }}
                    >
                      {doc?.photos?.map((photo: any) => (
                        <div
                          key={photo?.id}
                          id={`${photo?.id}-accept-reject`}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                            padding: '10px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            backgroundColor:
                              // eslint-disable-next-line no-nested-ternary
                              photo?.is_duplicate
                                ? '#e2e8f0'
                                : photo?.approved_status !== null
                                  ? photo?.approved_status === true
                                    ? 'lightgreen'
                                    : 'salmon'
                                  : photo?.remark
                                    ? '#fff6e0'
                                    : 'white',
                            minHeight: '280px',
                            position: 'relative',
                          }}
                        >
                          {/* Status Badge: Duplicate / Accepted / Rejected */}
                          {(photo?.is_duplicate || photo?.approved_status !== null) && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '14px',
                                left: '14px',
                                padding: '4px 10px',
                                borderRadius: '4px',
                                fontSize: '10px',
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                                color: 'white',
                                backgroundColor: photo?.is_duplicate
                                  ? '#475569'
                                  : photo?.approved_status === true
                                    ? '#28a745'
                                    : '#dc3545',
                                zIndex: 10,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                              }}
                            >
                              {photo?.is_duplicate
                                ? 'Duplicate'
                                : photo?.approved_status === true
                                  ? 'Accepted'
                                  : 'Rejected'}
                            </div>
                          )}

                          {/* Image/PDF Container - Fixed Height */}
                          <div
                            style={{
                              height: '200px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#f8fafc',
                              borderRadius: '4px',
                              overflow: 'hidden',
                            }}
                          >
                            {photo?.url &&
                            (photo.url.slice(-3) === 'pdf' || photo.url.slice(-4) === '.pdf') ? (
                              <>
                                <PdfViewer photo={photo?.url} />
                              </>
                            ) : (
                              <Image
                                width={200}
                                height={180}
                                style={{ objectFit: 'contain' }}
                                src={
                                  photo?.url?.startsWith('https') || !photo?.url
                                    ? photo?.url
                                    : `${BASE_IMAGE_URL}/${photo?.url}`
                                }
                                fallback={fallback}
                              />
                            )}
                          </div>

                          {/* Action Buttons */}
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px',
                              width: '100%',
                            }}
                          >
                            {/* Row 1: Edit Remark, Accept, Reject, Duplicate and Download */}
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '1.6fr 1fr 1fr 1fr 1fr',
                                gap: '8px',
                              }}
                            >
                              <Tooltip
                                title={
                                  photo?.remark
                                    ? `Current remarks: ${photo.remark}`
                                    : 'Add remarks to this document'
                                }
                                placement="topLeft"
                                overlayStyle={{
                                  maxWidth: '300px',
                                  wordWrap: 'break-word',
                                  whiteSpace: 'pre-wrap',
                                }}
                              >
                                <Button
                                  size="small"
                                  style={{
                                    backgroundColor: '#586f80',
                                    color: 'white',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    fontSize: '13px',
                                    height: '28px',
                                    width: '100%',
                                  }}
                                  onClick={handleAddRemarks(doc, photo)}
                                >
                                  {photo?.remark ? 'Edit Remark' : 'Add Remark'}
                                </Button>
                              </Tooltip>

                              <Tooltip placement="top" title={'Accept'}>
                                <Button
                                  size="small"
                                  disabled={
                                    documentActionLoadingStates[String(photo?.id)] ||
                                    (photo?.approved_status === true && !photo?.is_duplicate)
                                  }
                                  style={{
                                    color: 'black',
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    padding: '3px 8px',
                                    fontSize: '13px',
                                    height: '28px',
                                    width: '100%',
                                  }}
                                  onClick={() => documentAcceptRejectClick(true, photo?.id)}
                                >
                                  <CircleCheckBig size={20} />
                                </Button>
                              </Tooltip>
                              <Tooltip placement="bottom" title={'Reject'}>
                                <Button
                                  size="small"
                                  disabled={
                                    documentActionLoadingStates[String(photo?.id)] ||
                                    (photo?.approved_status === false && !photo?.is_duplicate)
                                  }
                                  style={{
                                    color: 'black',
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    padding: '3px 8px',
                                    fontSize: '13px',
                                    height: '28px',
                                    width: '100%',
                                  }}
                                  onClick={() => documentAcceptRejectClick(false, photo?.id)}
                                >
                                  <CircleX size={20} />
                                </Button>
                              </Tooltip>
                              <Tooltip
                                placement="top"
                                title={
                                  photo?.is_duplicate
                                    ? 'Remove duplicate mark'
                                    : 'Mark as duplicate'
                                }
                              >
                                <Button
                                  size="small"
                                  style={{
                                    color: photo?.is_duplicate ? '#1d4ed8' : 'black',
                                    border: 'none',
                                    backgroundColor: photo?.is_duplicate
                                      ? '#dbeafe'
                                      : 'transparent',
                                    borderRadius: '4px',
                                    padding: '3px 8px',
                                    fontSize: '13px',
                                    height: '28px',
                                    width: '100%',
                                  }}
                                  onClick={() =>
                                    documentDuplicateClick(!photo?.is_duplicate, photo?.id)
                                  }
                                >
                                  <Copy size={20} />
                                </Button>
                              </Tooltip>
                              <Tooltip placement="top" title={'Download'}>
                                <Button
                                  size="small"
                                  style={{
                                    color: 'black',
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    padding: '3px 8px',
                                    fontSize: '13px',
                                    height: '28px',
                                    width: '100%',
                                  }}
                                  onClick={() => onDownload(photo?.url)}
                                >
                                  <Download size={20} />
                                </Button>
                              </Tooltip>
                            </div>
                          </div>
                          <Tooltip
                            title={
                              photo?.documentType
                                ? `${photo?.documentCategory || ''}${photo?.documentCategory ? ' >' : ''}${photo?.documentType}`
                                : 'Tag this upload with a document type'
                            }
                          >
                            <Button
                              size="small"
                              style={{
                                backgroundColor: photo?.documentType ? '#2f6f4e' : '#0057a8',
                                color: 'white',
                                borderRadius: '4px',
                                width: '100%',
                                whiteSpace: 'normal',
                                height: '32px',
                                padding: '4px 8px',
                                border: 'none',
                                fontWeight: 600,
                                fontSize: '13px',
                              }}
                              icon={<TagsOutlined />}
                              onClick={() => openDocTypeModal(photo)}
                            >
                              {photo?.documentType ? photo.documentType : 'Assign Document Type'}
                            </Button>
                          </Tooltip>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {memberHasDocuments(member) && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  border: '1px solid #e5e5e5',
                  padding: '10px',
                  borderRadius: '8px',
                  width: '100%',
                  marginTop: '20px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    gap: '10px',
                  }}
                >
                  <InvertFillButton
                    variant="white"
                    fontSize="base"
                    fontWeight="medium"
                    disabled={!memberHasAcceptedDocuments(member) || downloadLoading}
                    onClick={(event: any) => {
                      event?.stopPropagation?.();
                      handleDownloadAcceptedDocuments(member);
                    }}
                  >
                    {downloadLoading ? <Spin size="small" /> : <DownloadOutlined />}
                    Download Accepted Documents
                  </InvertFillButton>
                  <InvertFillButton
                    variant="blue"
                    fontSize="base"
                    fontWeight="medium"
                    disabled={downloadLoading}
                    onClick={(event: any) => {
                      event?.stopPropagation?.();
                      handleDownloadAll(member);
                    }}
                  >
                    {downloadLoading ? <Spin size="small" /> : <DownloadOutlined />}
                    Download All Document
                  </InvertFillButton>
                  <InvertFillButton
                    variant="red"
                    fontSize="base"
                    fontWeight="medium"
                    disabled={combinedPdfLoading}
                    onClick={(event: any) => {
                      event?.stopPropagation?.();
                      handleDownloadAllCombined(member);
                    }}
                  >
                    {combinedPdfLoading ? <Spin size="small" /> : <DownloadOutlined />}
                    <span>
                      {combinedPdfLoading
                        ? 'Creating All Combined PDFs...'
                        : 'Download All Combined PDF'}
                    </span>
                  </InvertFillButton>
                </div>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            width: '100%',
            padding: '20px',
            marginTop: '20px',
            border: '1px solid rgb(226, 232, 240)',
            borderRadius: '8px',
          }}
        >
          {/* Empty document categories - 4-column grid */}
          {documentsWithoutPhotos.length > 0 && (
            <div>
              <div
                style={{
                  marginBottom: '20px',
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#475569',
                  textTransform: 'uppercase',
                  letterSpacing: '0.03em',
                  paddingBottom: '20px',

                  borderBottom: '1px dashed #cbd5e1',
                }}
              >
                <span style={{ color: '#1e293b' }}>Request Missing Document: </span>
                {paymentDetails?.packageName || 'Empty Category'}{' '}
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '2px 10px',
                    borderRadius: '999px',
                    border: '1px solid rgb(254, 215, 170)',
                    backgroundColor: 'rgb(255, 247, 237)',
                    color: 'rgb(194, 65, 12)',
                    fontSize: '11.5px',
                    fontWeight: 600,
                    lineHeight: 1.3,
                    letterSpacing: '0.01em',
                  }}
                >
                  {member?.ageGroup}
                </span>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                  gap: '15px',
                }}
              >
                {documentsWithoutPhotos.map((doc: any) => (
                  <div
                    key={doc?.id}
                    role="checkbox"
                    aria-checked={selectedMissingDocumentIds.includes(String(doc?.id))}
                    tabIndex={0}
                    onClick={() => {
                      const documentId = String(doc?.id);
                      setSelectedMissingDocumentIds(previous =>
                        previous.includes(documentId)
                          ? previous.filter(id => id !== documentId)
                          : [...previous, documentId]
                      );
                    }}
                    onKeyDown={event => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        const documentId = String(doc?.id);
                        setSelectedMissingDocumentIds(previous =>
                          previous.includes(documentId)
                            ? previous.filter(id => id !== documentId)
                            : [...previous, documentId]
                        );
                      }
                    }}
                    style={{
                      position: 'relative',
                      cursor: 'pointer',
                      padding: '12px',
                      borderRadius: '6px',
                      backgroundColor: selectedMissingDocumentIds.includes(String(doc?.id))
                        ? '#eff6ff'
                        : '#f8fafc',
                      border: selectedMissingDocumentIds.includes(String(doc?.id))
                        ? '1px solid #2563eb'
                        : '1px solid #e2e8f0',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedMissingDocumentIds.includes(String(doc?.id))}
                      onChange={() => undefined}
                      aria-label={`Select ${doc?.name || 'document'}`}
                      style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        margin: 0,
                        width: '16px',
                        height: '16px',
                        accentColor: '#2563eb',
                      }}
                    />

                    <Title
                      level={5}
                      style={{
                        margin: '0 24px 0 0',
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'black',
                      }}
                    >
                      {doc?.name}
                    </Title>
                  </div>
                ))}
              </div>
            </div>
          )}
          <DocumentReminderPanel
            orderId={formDetails?.id}
            orderDisplayId={formDetails?.orderId}
            member={member}
            applicantEmail={userDetails?.email}
            selectedDocumentIds={selectedMissingDocumentIds}
            onSelectionChange={setSelectedMissingDocumentIds}
            onStatusUpdated={(memberId: string, nextStatus: string) => {
              setMembers((prevMembers: any[]) =>
                prevMembers.map((m: any) => (m.id === memberId ? { ...m, status: nextStatus } : m))
              );
              setSavedMemberStatuses(prev => ({
                ...prev,
                [memberId]: getDocumitraAdminStatusValue(nextStatus),
              }));
            }}
            onReminderSent={() => setReminderHistoryRefreshKey(previous => previous + 1)}
          />
        </div>
        <div>
          <DocumentReminderHistory member={member} refreshKey={reminderHistoryRefreshKey} />
        </div>
      </div>
    );
  };

  const handleMergeDocumentsByType = async (
    memberId: string,
    documentId: string,
    documentData?: any
  ) => {
    const loadingKey = `${memberId}-${documentId}`;
    try {
      setMergeLoadingStates(prev => ({ ...prev, [loadingKey]: true }));

      // Comprehensive data validation
      console.log('=== FRONTEND: Data validation ===');
      console.log('Member ID:', memberId);
      console.log('Document ID:', documentId);
      console.log('Document data type:', typeof documentData);
      console.log('Document data keys:', Object.keys(documentData || {}));
      console.log('Document data:', documentData);

      // Prepare the data with actual file names, excluding rejected documents
      console.log('=== FRONTEND: Document data received ===');
      console.log('Document name:', documentData?.name);
      console.log('Original photos count:', documentData?.photos?.length);
      console.log(
        'Photo approval statuses:',
        documentData?.photos?.map((p: any) => ({
          id: p.id,
          approved_status: p.approved_status,
          approved_status_type: typeof p.approved_status,
          is_null: p.approved_status === null,
          is_undefined: p.approved_status === undefined,
          is_false: p.approved_status === false,
          is_true: p.approved_status === true,
        }))
      );

      // Filter to include all documents except rejected ones (approved and pending)
      const documentsWithFileNames =
        documentData?.photos
          ?.filter((photo: any) => {
            // Log each photo's approval status for debugging
            console.log(
              `Photo ${photo.id}: approved_status = ${photo?.approved_status}, type = ${typeof photo?.approved_status}`
            );

            // Check if approved_status is an object (which would be unusual)
            if (typeof photo?.approved_status === 'object' && photo?.approved_status !== null) {
              console.log(
                `Photo ${photo.id}: WARNING - approved_status is an object:`,
                photo?.approved_status
              );
            }

            // Exclude if explicitly rejected (false) or marked as duplicate
            const isRejected = photo?.approved_status === false || !!photo?.is_duplicate;
            console.log(`Photo ${photo.id}: isRejected/duplicate = ${isRejected}`);

            // Include if not rejected (approved or pending)
            const shouldInclude = !isRejected;
            console.log(`Photo ${photo.id}: shouldInclude = ${shouldInclude}`);

            return shouldInclude;
          })
          ?.map((photo: any) => {
            // Extract the original file name from the URL
            const urlParts = photo.url.split('/');
            const fileName = urlParts[urlParts.length - 1];
            // Remove any query parameters and get the base filename
            const cleanFileName = fileName.split('?')[0];
            // Decode URL-encoded characters to get the actual file name
            const decodedFileName = decodeURIComponent(cleanFileName);
            // Replace + signs with spaces to get the original file name
            const finalFileName = decodedFileName.replace(/\+/g, ' ');

            return {
              url: photo.url,
              fileName: finalFileName,
              photoId: photo.id,
            };
          }) || [];

      console.log('Filtered documents count:', documentsWithFileNames.length);
      console.log(
        'Documents to be merged:',
        documentsWithFileNames.map((d: any) => ({ fileName: d.fileName, photoId: d.photoId }))
      );

      // Don't proceed if no approved documents
      if (documentsWithFileNames.length === 0) {
        toastError('No approved documents found to merge');
        return;
      }

      const response = await fetch(`${BASE_API_URL}/pdf/merge/${memberId}/${documentId}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getToken(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          documents: documentsWithFileNames,
          sectionName: documentData?.name || 'Documents',
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to download merged PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // Clean the document name for filename (remove special characters and spaces)
      const cleanDocumentName = (documentData?.name || 'documents')
        .replace(/[^a-zA-Z0-9]/g, '_')
        .replace(/_+/g, '_');
      link.download = `merged_${cleanDocumentName}_${documentId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toastSuccess('Documents merged and downloaded successfully');
    } catch (error) {
      console.error('Error downloading merged PDF:', error);
      toastError('Failed to download merged documents. Please try again.');
    } finally {
      setMergeLoadingStates(prev => ({ ...prev, [loadingKey]: false }));
    }
  };

  const getUser = async (userId: string) => {
    try {
      const entityData: any = await callApi(`${ORDER_USER}/${userId}`, 'GET');
      const { isSuccess, data } = entityData;
      if (!isSuccess) {
        // eslint-disable-next-line no-console
        console.error('Something went wrong, please try again');
      }
      setUserDetails(data?.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Something went wrong, please try again');
    }
  };
  const getPackage = async (packageId: string) => {
    try {
      const entityData: any = await callApi(`${APPLICATION_FORM_PACKAGES}/${packageId}`, 'GET');
      const { isSuccess, data } = entityData;
      if (!isSuccess) {
        // eslint-disable-next-line no-console
        console.error('Something went wrong, please try again');
      }
      setPaymentDetails((prevState: any) => ({ ...prevState, packageName: data?.data?.name }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Something went wrong, please try again');
    }
  };

  // Unified function to handle all document uploads (first and subsequent)
  const handleDocumentUpload = async (e: any, currentMember: any, documentId?: string) => {
    const file = e.target.files[0];
    if (!file) return;

    // No validation needed - users can upload new documents freely
    // Validation only applies to the "Update PDF" button

    // Add timestamp to filename for PDF uploads
    let fileName = file.name;
    if (file.type === 'application/pdf' || fileName.toLowerCase().endsWith('.pdf')) {
      const now = new Date();
      const timestamp = now.toISOString().replace(/[:.]/g, '-').slice(0, 19); // Format: YYYY-MM-DDTHH-MM-SS
      const fileExtension = fileName.split('.').pop();
      const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, '');
      fileName = `${fileNameWithoutExt}_${timestamp}.${fileExtension}`;
    }

    const updatedFile = new File(
      [file],
      fileName, // Use filename with timestamp for PDFs
      {
        type: file.type,
        lastModified: file.lastModified,
      }
    );

    const formData = new FormData();
    formData.append('file', updatedFile);
    formData.append('userId', userDetails.id);
    formData.append('serviceName', '');
    formData.append('packageName', paymentDetails.packageName);
    formData.append('orderId', paymentDetails.orderId);

    try {
      const res: any = await uploadImageApiCall(`/application/upload`, formData);
      const { data, isSuccess } = res;

      if (isSuccess) {
        const existingDocument = currentMember?.processedDocument;
        const existingDocuments = currentMember?.processedDocuments;

        console.log('=== DOCUMENT UPLOAD DEBUG ===');
        console.log('Current member:', currentMember);
        console.log('Existing document:', existingDocument);
        console.log('Existing documents:', existingDocuments);
        console.log('Document ID (for replacement):', documentId);
        console.log('New data:', data);

        // Simplified approach: Always use processedDocuments array
        console.log('=== UPLOADING DOCUMENT ===');

        // Get existing documents (convert single document to array if needed)
        let existingDocs: any[] = [];
        if (currentMember?.processedDocuments && currentMember.processedDocuments.length > 0) {
          existingDocs = [...currentMember.processedDocuments];
        } else if (currentMember?.processedDocument?.url) {
          existingDocs = [currentMember.processedDocument];
        }

        // Add the new document to the array
        const newDocument = { ...data, id: data.id || Date.now() };
        const updatedDocuments = [...existingDocs, newDocument];

        // Update the member with the new documents array
        const updatedMembers = members?.map((m: any) => {
          if (m?.id === currentMember?.id) {
            return {
              ...m,
              processedDocuments: updatedDocuments,
              processedDocument: null, // Always clear single document, use array only
            };
          }
          return m;
        });

        console.log('Updated members:', updatedMembers);
        setMembers(updatedMembers);
        toastSuccess('Document uploaded successfully');

        // Update existing PDF status for this member
        const { id } = formDetails;
        const updatedPdfData = await checkExistingPdfForUser(id, currentMember.id);
        if (updatedPdfData) {
          setExistingPdfStatus(prev => ({
            ...prev,
            [currentMember.id]: updatedPdfData,
          }));
        }

        // Clear the file input
        e.target.value = '';
      }
    } catch (err) {
      console.error('Upload error:', err);
      toastError(`Oops, an error occurred! Upload failed. Please contact development support team`);
    }
  };

  // Function to check if PDF already exists for the user (enhanced to also check specific documents)
  const checkExistingPdfForUser = async (
    orderId: string,
    memberId: string,
    documentName?: string
  ) => {
    try {
      console.log('=== FRONTEND DEBUG: checkExistingPdfForUser ===');
      console.log('OrderId:', orderId);
      console.log('MemberId:', memberId);
      console.log('DocumentName:', documentName);
      console.log('DocumentName type:', typeof documentName);

      const endpoint = documentName
        ? `${CHECK_EXISTING_PDF}/${orderId}/${memberId}?documentName=${encodeURIComponent(documentName)}`
        : `${CHECK_EXISTING_PDF}/${orderId}/${memberId}`;

      console.log('Calling endpoint:', endpoint);
      const res = await callApi(endpoint, 'GET');

      console.log('=== FRONTEND DEBUG: API Response ===');
      console.log('Full response:', res);
      console.log('Response data:', res?.data);
      console.log('Response statusCode:', res?.data?.statusCode);

      if (res?.data?.statusCode === 200) {
        const data = res.data.data;
        console.log('=== FRONTEND DEBUG: Parsed Data ===');
        console.log('Data:', JSON.stringify(data, null, 2));
        console.log('specificDocumentExists:', data?.specificDocumentExists);
        console.log('hasExistingPdfs:', data?.hasExistingPdfs);
        return data;
      } else {
        console.error('Failed to check existing PDFs:', res);
        return null;
      }
    } catch (error) {
      console.error('Error checking existing PDFs:', error);
      return null;
    }
  };

  // Function to check existing PDF status for all members
  const checkExistingPdfStatusForAllMembers = async () => {
    if (!formDetails?.id || !members?.length) return;

    const statusMap: { [key: string]: any } = {};

    for (const member of members) {
      const existingPdfData = await checkExistingPdfForUser(formDetails.id, member.id);
      if (existingPdfData) {
        statusMap[member.id] = existingPdfData;
      }
    }

    setExistingPdfStatus(statusMap);
  };

  const updatePdf = async (
    event: any,
    memberId: any,
    documentId?: any,
    skipValidation: boolean = false
  ) => {
    event.preventDefault();

    // Set loading state for this specific update operation
    const loadingKey = `${memberId}-${documentId}`;
    setUpdatePdfLoadingStates(prev => ({ ...prev, [loadingKey]: true }));

    try {
      // Find the current member
      const currentMember = members.find((member: any) => member.id === memberId);
      if (!currentMember) {
        toastError('Member not found');
        return;
      }

      // Find the document to update
      let documentToUpdate = null;
      if (currentMember.processedDocument && currentMember.processedDocument.id === documentId) {
        documentToUpdate = currentMember.processedDocument;
      } else if (currentMember.processedDocuments) {
        documentToUpdate = currentMember.processedDocuments.find(
          (doc: any) => doc.id === documentId
        );
      }

      if (!documentToUpdate) {
        toastError('Document not found');
        return;
      }

      // Check if this specific document exists in the database for this user
      const { id } = formDetails;

      // Skip validation if called from batch update (we already checked this)
      if (!skipValidation) {
        console.log('=== FRONTEND DEBUG: updatePdf validation ===');
        console.log('DocumentId for validation:', documentId);
        console.log('DocumentName for validation:', documentToUpdate.name);
        console.log('MemberId:', memberId);
        console.log('OrderId:', id);

        const existingPdfData = await checkExistingPdfForUser(id, memberId, documentToUpdate.name);

        console.log('=== FRONTEND DEBUG: updatePdf validation result ===');
        console.log('existingPdfData:', existingPdfData);
        console.log('hasExistingPdfs:', existingPdfData?.hasExistingPdfs);
        console.log('specificDocumentExists:', existingPdfData?.specificDocumentExists);

        // Check if this specific document already exists for this user
        if (existingPdfData && existingPdfData.specificDocumentExists) {
          console.log(
            '=== FRONTEND DEBUG: updatePdf validation failed - specific document exists ==='
          );
          toastError(
            `This Document is already updated for this user. Please upload a new document.`
          );
          return;
        }
        console.log(
          '=== FRONTEND DEBUG: updatePdf validation passed - specific document does not exist ==='
        );
      }

      // If this specific document doesn't exist for this user, allow update

      const timeStamp = new Date().getTime();
      const fileName = documentToUpdate.name; // Keep original filename without modification

      const payload = { ...documentToUpdate, name: fileName, memberId: memberId };
      const res = await callApi(`${DOCUMITRA_ORDER_PROCESSED_PDF}/${id}`, 'PUT', payload);

      console.log('=== UPDATE PDF API RESPONSE ===');
      console.log('Full response:', res);
      console.log('Response status:', res?.status);
      console.log('Response data:', res?.data);
      console.log('Response data statusCode:', res?.data?.statusCode);

      // Check for the correct response structure from callApi function
      if (res?.status === true || res?.data?.statusCode === 200) {
        console.log('=== SUCCESS: PDF Update successful ===');

        // Only show success message if not called from batch update
        if (!skipValidation) {
          toastSuccess('Processed PDF updated successfully.');
        }

        // Get the updated document data from the response
        const updatedDocumentData = res?.data?.data || payload;
        console.log('=== UPDATED DOCUMENT DATA ===');
        console.log('Updated document data:', updatedDocumentData);

        // Update the local state immediately with the response data
        const updatedMembers = members.map((member: any) => {
          if (member.id === memberId) {
            // Update single processed document
            if (member.processedDocument && member.processedDocument.id === documentId) {
              return {
                ...member,
                processedDocument: {
                  ...member.processedDocument,
                  ...updatedDocumentData,
                  // Ensure we use the new ID from the response if available
                  id: updatedDocumentData.id || member.processedDocument.id,
                },
              };
            }
            // Update in processedDocuments array
            if (member.processedDocuments) {
              const updatedProcessedDocuments = member.processedDocuments.map((doc: any) => {
                if (doc.id === documentId) {
                  return {
                    ...doc,
                    ...updatedDocumentData,
                    // Ensure we use the new ID from the response if available
                    id: updatedDocumentData.id || doc.id,
                  };
                }
                return doc;
              });
              return { ...member, processedDocuments: updatedProcessedDocuments };
            }
          }
          return member;
        });

        setMembers(updatedMembers);
        console.log('=== SUCCESS: Members state updated with new document data ===');

        // Update existing PDF status for this member
        const updatedPdfData = await checkExistingPdfForUser(id, memberId);
        if (updatedPdfData) {
          setExistingPdfStatus(prev => ({
            ...prev,
            [memberId]: updatedPdfData,
          }));
        }

        // Refresh member data from server to ensure complete synchronization
        // Add a small delay to ensure server has processed the update
        setTimeout(async () => {
          await refreshMemberData();
        }, 500);
      } else {
        console.error('=== ERROR: PDF Update failed ===');
        console.error('API Response:', res);
        console.error('Status check failed - res.status:', res?.status);
        console.error('Status check failed - res.data.statusCode:', res?.data?.statusCode);
        toastError('Failed to update PDF');
      }
    } catch (error) {
      console.error('Error updating PDF:', error);
      toastError('Failed to update PDF. Please try again.');
    } finally {
      setUpdatePdfLoadingStates(prev => ({ ...prev, [loadingKey]: false }));
    }
  };

  // Function to refresh member data from server
  const refreshMemberData = async () => {
    try {
      console.log('=== REFRESHING MEMBER DATA FROM SERVER ===');
      const { id } = formDetails;

      // Fetch fresh data from the server
      const res = await callApi(`${ORDER_USER}/${id}`, 'GET');

      if (res?.data?.data?.members) {
        console.log('=== FRESH MEMBER DATA RECEIVED ===');
        console.log('Fresh members:', res.data.data.members);
        setMembers(res.data.data.members);
        syncSavedMemberStatuses(res.data.data.members);

        // Also refresh the existing PDF status
        await checkExistingPdfStatusForAllMembers();
      }
    } catch (error) {
      console.error('Error refreshing member data:', error);
    }
  };

  // New function to handle document replacement with file input

  useEffect(() => {
    if (!formDetails) {
      return;
    }
    const partnerDefinedServiceName = formDetails?.partnerPackage?.name;
    if (partnerDefinedServiceName) {
      setServiceName(partnerDefinedServiceName);
    } else {
      const extractServiceName = async () => {
        try {
          const res = await callApi(`${APPLICATION_FORM_SERVICES}/${formDetails.serviceId}`, 'GET');
          setServiceName(res?.data?.data?.name);
        } catch (error) {
          console.error('Error', error);
        }
      };
      extractServiceName();
    }
    const { members } = formDetails;
    let copy_members = members;
    setMembers(members);
    syncSavedMemberStatuses(members);
    if (!hasAutoSelectedMemberTab) {
      const userRole = getRole();
      if (
        userRole !== 'Accountant' &&
        Array.isArray(members) &&
        members.length > 0 &&
        members[0]?.id
      ) {
        const firstMemberId = members[0].id;
        setActivePrimaryTab(`member-${firstMemberId}`);
        setActiveSecondaryTabs(prevSecondary => {
          if (prevSecondary[firstMemberId]) return prevSecondary;
          return { ...prevSecondary, [firstMemberId]: `notes-${firstMemberId}` };
        });
        fetchMemberNotes(firstMemberId);
        setHasAutoSelectedMemberTab(true);
      }
    }
    let tempArr: any = [];
    if (members && members.length > 0 && members[0]?.documents && members[0].documents.length > 0) {
      console.log('Members', members[0].documents[0]);
    }
    members?.map((member: any) => {
      member?.documents?.map((item: any) => {
        if (item.photos && item.photos.length > 0) {
          item.photos.map((photo: any) => {
            if (photo?.url && typeof photo.url === 'string' && photo.url.slice(-3) === 'pdf') {
              let tempObj = { id: 0, data: '' };
              tempObj.id = photo?.id;
              tempObj.data = photo?.url;
              tempArr.push(photo);
            }
          });
        }
      });
    });
    Promise.all(tempArr.map((photo: any) => handlePresignedUrl(photo)))
      .then(results => {
        const newContent = results
          .filter(result => result !== null) // filter out any null results
          .map(result => result as { id: string; data: string }); // type assertion for non-null results
        setPresignedContent(newContent);
      })
      .catch(error => console.error('Error fetching all presigned URLs:', error));
    const payment = {
      id: formDetails?.id,
      expedite: formDetails?.expedite, //price
      apostilled: formDetails?.apostilled, //price
      photoEnhancement: formDetails?.photoEnhancement, //price
      courierService: formDetails?.courierService, //price
      pricingPlan: formDetails?.pricingPlan, //discounted price
      convenienceFee: formDetails?.convenienceFee,
      payableOfferPrice: formDetails?.payableOfferPrice, // totalDiscountedprice + convenience fees
      orderId: formDetails?.orderId,
      trackingId: formDetails?.trackingId,
      expectedDate: formDetails?.expectedDate,
      appliedCoupon: formDetails?.appliedCoupon,
      couponDiscount: formDetails?.couponDiscount,
      paymentDate: formDetails?.paymentDetails?.paymentDate,
      paymentMethod: formDetails?.paymentDetails?.paymentMethod,
      orderDate: formDetails?.createdAt,
      paymentDetails: formDetails?.paymentDetails || {},
    };
    getUser(formDetails?.userId);
    getPackage(formDetails?.packageId);
    setPaymentDetails(payment);
    checkExistingPdfStatusForAllMembers();
  }, [formDetails]);

  const currentUserRole: any = getRole();

  const [memberNotes, setMemberNotes] = useState<Record<string, any[]>>({});
  const [notesLoading, setNotesLoading] = useState<Record<string, boolean>>({});
  const [newNoteText, setNewNoteText] = useState<string>('');

  const fetchMemberNotes = async (memberId: string) => {
    if (memberNotes[memberId]) return;
    setNotesLoading(prev => ({ ...prev, [memberId]: true }));
    try {
      const response: any = await callApi(`${DOCUMITRA_MEMBER_NOTES}/${memberId}`, 'GET');
      const payload = response?.data?.data ?? response?.data ?? response;
      setMemberNotes(prev => ({
        ...prev,
        [memberId]: Array.isArray(payload) ? payload : payload?.notes || [],
      }));
    } catch (error) {
      console.error('Failed to fetch member notes:', error);
      toastError('Failed to load notes');
    } finally {
      setNotesLoading(prev => ({ ...prev, [memberId]: false }));
    }
  };

  useEffect(() => {
    if (members && members.length > 0) {
      members.forEach((member: any) => {
        if (member?.id) {
          fetchMemberNotes(member.id);
        }
      });
    }
  }, [members]);

  const isEmptyNoteHtml = (html: string) =>
    !(html || '')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();

  const handleAddNote = async (memberId: string) => {
    if (isEmptyNoteHtml(newNoteText)) return;
    try {
      const response: any = await callApi(`${DOCUMITRA_MEMBER_NOTES}/${memberId}`, 'POST', {
        noteText: newNoteText,
      });
      const note = response?.data?.data ?? response?.data;
      setMemberNotes(prev => ({
        ...prev,
        [memberId]: note ? [note, ...(prev[memberId] || [])] : prev[memberId] || [],
      }));
      setNewNoteText('');
      toastSuccess('Note added');
    } catch (error) {
      toastError('Failed to add note');
    }
  };

  const handleDeleteNote = async (memberId: string, noteId: string) => {
    try {
      await callApi(`${DOCUMITRA_MEMBER_NOTES}/${noteId}`, 'DELETE');
      setMemberNotes(prev => ({
        ...prev,
        [memberId]: (prev[memberId] || []).filter((note: any) => note.id !== noteId),
      }));
      toastSuccess('Note deleted');
    } catch (error) {
      toastError('Failed to delete note');
    }
  };

  // Helper function to get all preview forms for a member
  // (Final Forms / Government Issued Documents are rendered by DocumitraTeamDocuments)
  const getAllDocuments = (member: any) => {
    const allDocuments: any[] = [];

    // Add documents from processedDocuments array
    if (member?.processedDocuments && member.processedDocuments.length > 0) {
      allDocuments.push(
        ...member.processedDocuments.filter((doc: any) => isPreviewProcessedDocument(doc))
      );
    }

    // If no processedDocuments array, check for single processedDocument and convert it
    if (allDocuments.length === 0 && member?.processedDocument?.url) {
      allDocuments.push(member.processedDocument);
    }

    return allDocuments;
  };

  // Function to handle updating all PDFs for a member at once
  const handleUpdateAllPdfs = async (memberId: string, documents: any[]) => {
    if (!documents || documents.length === 0) {
      toastWarning('No documents to update');
      return;
    }

    setUpdateAllLoading(true);

    try {
      console.log('=== FRONTEND DEBUG: handleUpdateAllPdfs ===');
      console.log('MemberId:', memberId);
      console.log('Documents count:', documents.length);
      console.log('Form details ID:', formDetails?.id);

      // Prepare the documents data for bulk update
      const documentsData = documents.map(doc => ({
        memberId: memberId, // Each document needs memberId
        url: doc.url,
        size: doc.size,
        remark: doc.remark || '',
        status: false, // Status should be boolean, set to false (pending) so admins can review before accepting
        name: doc.name,
      }));

      console.log('=== FRONTEND DEBUG: Documents data prepared ===');
      console.log('Documents data:', documentsData);

      // Call the new bulk update endpoint
      const response = await callApi(`${BULK_UPDATE_PDFS}-${memberId}-${formDetails?.id}`, 'POST', {
        memberId: memberId,
        documents: documentsData,
      });

      console.log('=== FRONTEND DEBUG: Bulk update response ===');
      console.log('Response:', response);

      if (response?.data?.statusCode === 200 || response?.status === true) {
        const responseData = response?.data?.data || response?.data || response;

        // Show detailed success message based on response
        if (responseData.totalSkipped > 0) {
          toastSuccess(`Successfully processed ${responseData.totalProcessed} new document.`);
        } else {
          toastSuccess(`Successfully processed ${responseData.totalProcessed} documents`);
        }

        // Refresh the data after successful update
        await refreshMemberData();
      } else if (response?.data?.statusCode === 400) {
        // Handle case where no new documents were found
        const responseData = response?.data?.data || response?.data || response;
        if (responseData.totalProcessed === 0 && responseData.totalSkipped > 0) {
          toastError(`Please upload new documents, these documents are already updated.`);
        } else {
          toastError('Failed to update documents. Please try again.');
        }
      } else {
        console.error('Failed to update documents:', response);
        toastError('Failed to update documents. Please try again.');
      }
    } catch (error) {
      console.error('Error updating all PDFs:', error);
      toastError('Failed to update documents. Please try again.');
    } finally {
      setUpdateAllLoading(false);
    }
  };

  const handleDownloadClick = () => {
    console.log('download url', members[0]);
    if (members[0]?.processedDocument?.url) {
      const link = document.createElement('a');

      link.href =
        members[0]?.processedDocument?.url?.startsWith('https') ||
        !members[0]?.processedDocument?.url;
      !members[0]?.processedDocument?.url
        ? members[0]?.processedDocument?.url
        : `${BASE_IMAGE_URL}/${members[0]?.processedDocument?.url}`;
      link.setAttribute('download', 'downloaded_file.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const memberDetailsLocked = isOrderAndPaymentPending();

  useEffect(() => {
    if (memberDetailsLocked && activePrimaryTab.startsWith('member-')) {
      setActivePrimaryTab('user-details');
    }
  }, [activePrimaryTab, memberDetailsLocked]);

  useEffect(() => {
    if (activePrimaryTab === 'refund-request') {
      setActivePrimaryTab('payment-details');
    }
  }, [activePrimaryTab]);

  useEffect(() => {
    onPrimaryTabChange?.(activePrimaryTab);
  }, [activePrimaryTab, onPrimaryTabChange]);

  const memberHasDocuments = (member: any) =>
    !!member?.documents?.some((doc: any) => doc?.photos?.some((photo: any) => photo?.url));

  const memberHasAcceptedDocuments = (member: any) =>
    !!member?.documents?.some((doc: any) =>
      doc?.photos?.some(
        (photo: any) => photo?.approved_status === true && !photo?.is_duplicate && photo?.url
      )
    );

  const memberHeaderButtonStyle = (enabled: boolean) => ({
    borderRadius: '4px',
    height: '28px',
    padding: '0 12px',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: enabled ? '#586f80' : undefined,
    borderColor: enabled ? '#586f80' : undefined,
    color: enabled ? 'white' : undefined,
  });

  const renderMemberHeader = (member: any) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        width: '100%',
        minHeight: '40px',
      }}
    >
      <Text strong style={{ minWidth: 0, wordBreak: 'break-word' }}>
        {member?.name}
      </Text>
      <Space size={8} style={{ flexShrink: 0 }}>
        <InvertFillButton
          variant="white"
          fontSize="base"
          fontWeight="medium"
          disabled={!member?.formData}
          onClick={(event: any) => {
            event.stopPropagation();
            handleDownloadForm(member);
          }}
        >
          <DownloadOutlined /> Download Form
        </InvertFillButton>
        <InvertFillButton
          variant="blue"
          fontSize="base"
          fontWeight="medium"
          disabled={!memberHasDocuments(member) || downloadLoading}
          onClick={(event: any) => {
            event.stopPropagation();
            handleDownloadAll(member);
          }}
        >
          {downloadLoading ? <Spin size="small" /> : <DownloadOutlined />} Download All Document
        </InvertFillButton>
      </Space>
    </div>
  );

  const renderGovernmentStatusStrip = (member: any) => {
    const rawStatus = member?.status || formDetails?.memberStatus || formDetails?.status;
    const applicationStatus = getApplicationStatusValue(rawStatus);
    const governmentStatus = isGovernmentStatus(member?.status)
      ? getDocumitraAdminStatusValue(member?.status)
      : undefined;
    const savedGovernmentStatus = isGovernmentStatus(savedMemberStatuses[member.id])
      ? getDocumitraAdminStatusValue(savedMemberStatuses[member.id])
      : undefined;
    const canUpdateGovernmentStatus = applicationStatus === 'Application Completed';
    const hasGovernmentStatusChanged = governmentStatus !== savedGovernmentStatus;
    const isRejectedByAuthoritySelected = isDocumitraRejectedByAuthorityStatus(governmentStatus);
    const isRejectedByAuthoritySaved = isDocumitraMemberRejectedByAuthority(member);
    const isWithdrawalSaved =
      getDocumitraAdminStatusValue(savedMemberStatuses[member.id]) === 'Withdrawal by applicant' ||
      getDocumitraAdminStatusValue(member?.status) === 'Withdrawal by applicant';
    const savedGovernmentRemark = String(member?.governmentStatusRemark || '').trim();
    const draftGovernmentRemark =
      governmentRemarkDrafts[member.id] !== undefined
        ? governmentRemarkDrafts[member.id]
        : savedGovernmentRemark;
    const rejectionOutcome = rejectionOutcomeDrafts[member.id];
    const isRejectionOutcomeMissing = isRejectedByAuthoritySelected && !rejectionOutcome;
    const isGovernmentRemarkMissing =
      isRejectedByAuthoritySelected && !draftGovernmentRemark.trim();
    const hasGovernmentRemarkChanged =
      isRejectedByAuthoritySelected && draftGovernmentRemark.trim() !== savedGovernmentRemark;
    const canSubmitGovernmentStatus =
      canUpdateGovernmentStatus &&
      !!governmentStatus &&
      (hasGovernmentStatusChanged || hasGovernmentRemarkChanged || !!rejectionOutcome) &&
      !isGovernmentRemarkMissing &&
      !isRejectionOutcomeMissing;
    // Badge shows only the selected outcome (Rejected / Withdrawal), not the long status label
    const outcomeBadgeLabel = isRejectedByAuthoritySaved
      ? 'Rejected'
      : isWithdrawalSaved
        ? 'Withdrawal'
        : savedGovernmentStatus;

    return (
      <div
        style={{
          width: '100%',
          borderRadius: '10px',
          border: '1px solid #e2e8f0',
          background: '#fff',
          padding: '18px 20px',
          marginBottom: '18px',
        }}
      >
        <div
          style={{
            fontSize: '16px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: 'black',
            marginBottom: '14px',
            paddingBottom: '10px',
            borderBottom: '1px solid #e2e8f0',
            lineHeight: 1.2,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'space-between',
          }}
        >
          <div> Government Status </div>
          {outcomeBadgeLabel && (
            <div style={{ display: 'flex', gap: '10px' }}>
              <span
                title={
                  isRejectedByAuthoritySaved || isWithdrawalSaved
                    ? savedGovernmentRemark || undefined
                    : undefined
                }
                style={{
                  padding: '3px 12px',
                  borderRadius: '999px',
                  border: isRejectedByAuthoritySaved
                    ? '1px solid #fecaca'
                    : isWithdrawalSaved
                      ? '1px solid #fbbf24'
                      : '1px solid #bfdbfe',
                  backgroundColor: isRejectedByAuthoritySaved
                    ? '#fef2f2'
                    : isWithdrawalSaved
                      ? '#fffbeb'
                      : '#eff6ff',
                  color: isRejectedByAuthoritySaved
                    ? '#b91c1c'
                    : isWithdrawalSaved
                      ? '#b45309'
                      : '#1d4ed8',
                  fontSize: '12px',
                  fontWeight: 700,
                  letterSpacing: '0.03em',
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                }}
              >
                {outcomeBadgeLabel}
              </span>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <Text style={{ fontSize: '16px', fontWeight: '600', minWidth: '130px' }}>
            Government Status:
          </Text>
          <Select
            style={{ width: 300, fontSize: '16px' }}
            value={governmentStatus}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) => {
              const opt = option as unknown as Record<string, any>;
              const label = String(opt?.searchLabel ?? opt?.name ?? opt?.value ?? '');
              return label.toLowerCase().includes(input.toLowerCase());
            }}
            menuItemSelectedIcon={null}
            optionLabelProp="displayLabel"
            options={governmentStatusSelectOptions.map((opt: any) => {
              const optionValue = String(opt?.value ?? '');
              const searchLabel = String(opt?.label ?? opt?.name ?? optionValue ?? '');
              const isSelected = optionValue === String(governmentStatus);
              return {
                ...opt,
                searchLabel,
                displayLabel: searchLabel,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '2px 0',
                      fontSize: '14px',
                      fontWeight: isSelected ? 600 : 500,
                      color: isSelected ? '#075dc5' : '#1f2937',
                      lineHeight: 1.2,
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '3px',
                        border: isSelected ? '2px solid #075dc5' : '1.5px solid #94a3b8',
                        backgroundColor: isSelected ? '#075dc5' : '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        transition: 'background-color 0.15s ease, border-color 0.15s ease',
                        boxShadow: isSelected ? '0 1px 3px rgba(7, 93, 197, 0.3)' : 'none',
                      }}
                    >
                      {isSelected && (
                        <Check
                          size={11}
                          strokeWidth={3.5}
                          color="#ffffff"
                          style={{ display: 'block' }}
                        />
                      )}
                    </div>
                    <span
                      style={{
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {searchLabel}
                    </span>
                  </div>
                ),
              };
            })}
            placeholder="Select government status"
            disabled={!canUpdateGovernmentStatus}
            loading={memberStatusLoadingStates[member.id]}
            onChange={value => {
              const updatedMembers = members.map((m: any) => {
                if (m.id === member.id) {
                  return { ...m, status: value };
                }
                return m;
              });
              setMembers(updatedMembers);
              if (!isDocumitraRejectedByAuthorityStatus(value)) {
                setRejectionOutcomeDrafts(prev => {
                  const next = { ...prev };
                  delete next[member.id];
                  return next;
                });
              }
            }}
            size="middle"
          />
          <Button
            type="primary"
            disabled={!canSubmitGovernmentStatus}
            loading={memberStatusLoadingStates[member.id]}
            onClick={() => {
              if (!governmentStatus) {
                toastError('Please select a government status');
                return;
              }
              if (isRejectedByAuthoritySelected) {
                if (!rejectionOutcome) {
                  toastError('Please select Rejected or Withdrawal');
                  return;
                }
                if (isGovernmentRemarkMissing) {
                  toastError('Please add a remark for "Application Rejected by Authority"');
                  return;
                }
                const statusToSave =
                  rejectionOutcome === 'withdrawal' ? 'Withdrawal by applicant' : governmentStatus;
                handleMemberStatusUpdate(member.id, statusToSave, draftGovernmentRemark.trim());
                return;
              }
              handleMemberStatusUpdate(member.id, governmentStatus);
            }}
            style={{
              fontSize: '16px',
              height: '32px',
              padding: '0 20px',
              backgroundColor: canSubmitGovernmentStatus ? '#004195' : undefined,
              borderColor: canSubmitGovernmentStatus ? '#004195' : undefined,
              borderRadius: '4px',
            }}
          >
            Update
          </Button>
        </div>
        {isRejectedByAuthoritySelected && (
          <div style={{ marginTop: '14px' }}>
            <Text
              strong
              style={{ display: 'block', marginBottom: '8px', fontSize: '14px', color: '#0f172a' }}
            >
              Outcome (required)
            </Text>
            <Radio.Group
              value={rejectionOutcome}
              disabled={!canUpdateGovernmentStatus}
              onChange={e =>
                setRejectionOutcomeDrafts(prev => ({
                  ...prev,
                  [member.id]: e.target.value,
                }))
              }
              style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '12px' }}
            >
              <Radio
                value="rejected"
                style={{
                  padding: '8px 14px',
                  borderRadius: '8px',
                  border:
                    rejectionOutcome === 'rejected' ? '1px solid #f87171' : '1px solid #e2e8f0',
                  backgroundColor: rejectionOutcome === 'rejected' ? '#fef2f2' : '#ffffff',
                  fontWeight: 600,
                }}
              >
                Rejected
              </Radio>
              <Radio
                value="withdrawal"
                style={{
                  padding: '8px 14px',
                  borderRadius: '8px',
                  border:
                    rejectionOutcome === 'withdrawal' ? '1px solid #fbbf24' : '1px solid #e2e8f0',
                  backgroundColor: rejectionOutcome === 'withdrawal' ? '#fffbeb' : '#ffffff',
                  fontWeight: 600,
                }}
              >
                Withdrawal
              </Radio>
            </Radio.Group>
            <Text
              type="secondary"
              style={{ display: 'block', marginBottom: '10px', fontSize: '12px' }}
            >
              {rejectionOutcome === 'withdrawal'
                ? 'Withdrawal sets government status to "Withdrawal by applicant".'
                : rejectionOutcome === 'rejected'
                  ? 'Rejected tags the member and moves Application Status to Fill Form so the form can be re-done.'
                  : 'Choose whether the authority rejected the application or it was withdrawn.'}
            </Text>
            <Text
              strong
              style={{ display: 'block', marginBottom: '6px', fontSize: '14px', color: '#b91c1c' }}
            >
              Remark (required)
              {rejectionOutcome === 'rejected'
                ? " — included in the applicant's email"
                : rejectionOutcome === 'withdrawal'
                  ? ' — internal only (no email for withdrawal)'
                  : ''}
            </Text>
            <Input.TextArea
              value={draftGovernmentRemark}
              onChange={e =>
                setGovernmentRemarkDrafts(prev => ({ ...prev, [member.id]: e.target.value }))
              }
              placeholder="Reason / remark from the authority, next steps for the applicant..."
              autoSize={{ minRows: 2, maxRows: 6 }}
              maxLength={2000}
              disabled={!canUpdateGovernmentStatus}
              style={{
                borderRadius: '6px',
                borderColor: isGovernmentRemarkMissing ? '#f87171' : undefined,
              }}
            />
          </div>
        )}
        {(isRejectedByAuthoritySaved || isWithdrawalSaved) &&
          !isRejectedByAuthoritySelected &&
          savedGovernmentRemark && (
            <div
              style={{
                marginTop: '14px',
                padding: '10px 12px',
                borderRadius: '8px',
                border: isWithdrawalSaved ? '1px solid #fde68a' : '1px solid #fecaca',
                backgroundColor: isWithdrawalSaved ? '#fffbeb' : '#fef2f2',
                fontSize: '13px',
                color: isWithdrawalSaved ? '#92400e' : '#7f1d1d',
                whiteSpace: 'pre-wrap',
              }}
            >
              <strong>Saved remark:</strong> {savedGovernmentRemark}
            </div>
          )}
        {isRejectedByAuthoritySaved && (
          <Text type="secondary" style={{ display: 'block', marginTop: '8px', fontSize: '13px' }}>
            Outcome: Rejected — application status was moved to Fill Form so the form can be
            re-done. Saving another government status clears this.
          </Text>
        )}
        {isWithdrawalSaved && !isRejectedByAuthoritySaved && (
          <Text type="secondary" style={{ display: 'block', marginTop: '8px', fontSize: '13px' }}>
            Outcome: Withdrawal
          </Text>
        )}
        {!canUpdateGovernmentStatus && (
          <Text
            type="secondary"
            style={{
              display: 'block',
              marginTop: '8px',
              marginLeft: '0px',
            }}
          >
            Government status can be updated after Application Status is Application Completed.
          </Text>
        )}
      </div>
    );
  };

  return (
    <>
      {/* PRIMARY TOP CARD: Order ID (left) + Primary Tabs (right) */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',

          width: '100%',
          padding: '16px 20px',
          borderRadius: '12px',
          border: '1px solid #e2e8f0',
          backgroundColor: '#ffffff',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            flexShrink: 0,
          }}
        >
          <div
          // style={{
          //   width: '56px',
          //   height: '56px',
          //   borderRadius: '12px',
          //   backgroundColor: '#e6f0ff',
          //   display: 'flex',
          //   alignItems: 'center',
          //   justifyContent: 'center',
          //   color: '#0b63d1',
          //   flexShrink: 0,
          // }}
          >
            {/* <IdCard size={32} strokeWidth={2} /> */}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '2px',
              position: 'absolute',
              backgroundColor: 'aliceblue',
              border: '1px solid rgb(226, 232, 240)',
              padding: '0px 8px',
              borderRadius: '4px',
              top: '-29px',
            }}
          >
            {/* <Text
              style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#64748b',
                margin: 0,
                lineHeight: 1.2,
              }}
            >
              Order ID
            </Text> */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Text
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#0f172a',
                  margin: 0,
                  lineHeight: 1.2,
                  letterSpacing: '-0.01em',
                }}
              >
                {formDetails?.orderId}
              </Text>
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                <button
                  type="button"
                  title={orderIdCopied ? 'Copied!' : 'Copy Order ID'}
                  onClick={() => {
                    if (formDetails?.orderId && navigator?.clipboard) {
                      navigator.clipboard
                        .writeText(String(formDetails.orderId))
                        .then(() => {
                          setOrderIdCopied(true);
                          window.setTimeout(() => setOrderIdCopied(false), 1600);
                        })
                        .catch(() => {});
                    }
                  }}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '6px',
                    border: 'none',
                    background: orderIdCopied ? '#e6f4ea' : 'transparent',
                    cursor: 'pointer',
                    color: orderIdCopied ? '#1e8e3e' : '#0b63d1',
                    padding: 0,
                    transition: 'background-color 0.15s ease, color 0.15s ease',
                  }}
                  onMouseEnter={e => {
                    if (!orderIdCopied) {
                      e.currentTarget.style.backgroundColor = '#eef2ff';
                    }
                  }}
                  onMouseLeave={e => {
                    if (!orderIdCopied) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  {orderIdCopied ? (
                    <CircleCheckBig size={18} strokeWidth={2.25} />
                  ) : (
                    <Clipboard size={18} strokeWidth={2} />
                  )}
                </button>
                {orderIdCopied && (
                  <span
                    style={{
                      position: 'absolute',
                      top: 'calc(100% + 4px)',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      whiteSpace: 'nowrap',
                      backgroundColor: '#0f172a',
                      color: '#ffffff',
                      fontSize: '11px',
                      fontWeight: 600,
                      padding: '4px 8px',
                      borderRadius: '4px',
                      boxShadow: '0 4px 10px rgba(15, 23, 42, 0.2)',
                      zIndex: 50,
                      pointerEvents: 'none',
                      letterSpacing: '0.01em',
                    }}
                  >
                    Copied!
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px',
            overflowX: 'auto',
            flexFlow: 'wrap',
            padding: '4px',
            backgroundColor: '#eef1f5',
            border: '0',
            borderRadius: '10px',
            scrollbarWidth: 'none',
          }}
        >
          <button
            type="button"
            onClick={() => setActivePrimaryTab('user-details')}
            style={{
              flex: '0 0 auto',
              padding: '7px 16px',
              border: '0',
              borderRadius: '7px',
              background: activePrimaryTab === 'user-details' ? '#ffffff' : 'transparent',
              color: activePrimaryTab === 'user-details' ? '#004195' : '#60758d',
              fontWeight: 600,
              fontSize: 'medium',
              letterSpacing: '0.01em',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              boxShadow:
                activePrimaryTab === 'user-details'
                  ? '0 1px 2px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)'
                  : 'none',
              transition: 'color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease',
            }}
          >
            <User size={15} strokeWidth={2.25} />
            User Details
          </button>

          <button
            type="button"
            onClick={() => setActivePrimaryTab('payment-details')}
            style={{
              flex: '0 0 auto',
              padding: '7px 16px',
              border: '0',
              borderRadius: '7px',
              background: activePrimaryTab === 'payment-details' ? '#ffffff' : 'transparent',
              color: activePrimaryTab === 'payment-details' ? '#004195' : '#60758d',
              fontWeight: 600,
              fontSize: 'medium',
              letterSpacing: '0.01em',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              boxShadow:
                activePrimaryTab === 'payment-details'
                  ? '0 1px 2px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)'
                  : 'none',
              transition: 'color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease',
            }}
          >
            <CreditCard size={15} strokeWidth={2.25} />
            Payment Details
          </button>

          {currentUserRole !== 'Accountant' &&
            members?.map((member: any) => {
              const tabId = `member-${member?.id}`;
              const isActive = activePrimaryTab === tabId;
              const appStatus = getDocumitraAdminStatusValue(
                member?.status || formDetails?.memberStatus || formDetails?.status
              );
              const normalizedStatus = String(appStatus || '')
                .trim()
                .toLowerCase();
              let badgeBg = '#eef2ff';
              let badgeBorder = '#c7d2fe';
              let badgeColor = '#3730a3';
              if (
                normalizedStatus.includes('complete') ||
                normalizedStatus.includes('approved') ||
                normalizedStatus.startsWith('fill')
              ) {
                if (
                  normalizedStatus.includes('complete') ||
                  normalizedStatus.includes('approved')
                ) {
                  badgeBg = '#ecfdf5';
                  badgeBorder = '#a7f3d0';
                  badgeColor = '#047857';
                } else {
                  badgeBg = '#fffbeb';
                  badgeBorder = '#fde68a';
                  badgeColor = '#92400e';
                }
              } else if (
                normalizedStatus.includes('reject') ||
                normalizedStatus.includes('decline') ||
                normalizedStatus.includes('cancel')
              ) {
                badgeBg = '#fef2f2';
                badgeBorder = '#fecaca';
                badgeColor = '#b91c1c';
              } else if (
                normalizedStatus.includes('pending') ||
                normalizedStatus.includes('review') ||
                normalizedStatus.includes('wait') ||
                normalizedStatus.includes('in progress') ||
                normalizedStatus.includes('processing')
              ) {
                badgeBg = '#fff7ed';
                badgeBorder = '#fed7aa';
                badgeColor = '#c2410c';
              } else if (
                normalizedStatus.includes('email') ||
                normalizedStatus.includes('send') ||
                normalizedStatus.includes('dispatch') ||
                normalizedStatus.includes('courier')
              ) {
                badgeBg = '#eff6ff';
                badgeBorder = '#bfdbfe';
                badgeColor = '#1d4ed8';
              }
              return (
                <button
                  key={member?.id}
                  type="button"
                  disabled={memberDetailsLocked}
                  aria-disabled={memberDetailsLocked}
                  onClick={() => {
                    if (!memberDetailsLocked) {
                      setActivePrimaryTab(tabId);
                    }
                  }}
                  style={{
                    flex: '0 0 auto',
                    padding: '7px 12px 7px 16px',
                    border: '0',
                    borderRadius: '7px',
                    background: isActive ? '#ffffff' : 'transparent',
                    color: isActive ? '#004195' : '#60758d',
                    fontWeight: 600,
                    fontSize: 'medium',
                    letterSpacing: '0.01em',
                    cursor: memberDetailsLocked ? 'not-allowed' : 'pointer',
                    opacity: memberDetailsLocked ? 0.55 : 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: isActive
                      ? '0 1px 2px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)'
                      : 'none',
                    transition:
                      'color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease',
                  }}
                >
                  <User size={15} strokeWidth={2.25} />
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        maxWidth: '160px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        verticalAlign: 'middle',
                      }}
                    >
                      {member?.name}
                    </span>
                    {appStatus && (
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 10px',
                          borderRadius: '999px',
                          border: `1px solid ${badgeBorder}`,
                          backgroundColor: badgeBg,
                          color: badgeColor,
                          fontSize: '11.5px',
                          fontWeight: 600,
                          lineHeight: 1.3,
                          letterSpacing: '0.01em',
                          maxWidth: '170px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          verticalAlign: 'middle',
                          flexShrink: 0,
                        }}
                      >
                        {appStatus}
                      </span>
                    )}
                    {isDocumitraMemberRejectedByAuthority(member) && (
                      <span
                        title={member?.governmentStatusRemark || undefined}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 10px',
                          borderRadius: '999px',
                          border: '1px solid #fecaca',
                          backgroundColor: '#fef2f2',
                          color: '#b91c1c',
                          fontSize: '11px',
                          fontWeight: 700,
                          lineHeight: 1.3,
                          letterSpacing: '0.02em',
                          textTransform: 'uppercase',
                          whiteSpace: 'nowrap',
                          flexShrink: 0,
                        }}
                      >
                        Rejected
                      </span>
                    )}
                    {getDocumitraAdminStatusValue(member?.status) === 'Withdrawal by applicant' &&
                      !isDocumitraMemberRejectedByAuthority(member) && (
                        <span
                          title={member?.governmentStatusRemark || undefined}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '2px 10px',
                            borderRadius: '999px',
                            border: '1px solid #fbbf24',
                            backgroundColor: '#fffbeb',
                            color: '#b45309',
                            fontSize: '11px',
                            fontWeight: 700,
                            lineHeight: 1.3,
                            letterSpacing: '0.02em',
                            textTransform: 'uppercase',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                          }}
                        >
                          Withdrawal
                        </span>
                      )}
                    {isDocumitraMemberOnHold(member) && (
                      <span
                        title={member?.onHoldRemark || undefined}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 10px',
                          borderRadius: '999px',
                          border: '1px solid #fed7aa',
                          backgroundColor: '#fff7ed',
                          color: '#c2410c',
                          fontSize: '11px',
                          fontWeight: 700,
                          lineHeight: 1.3,
                          letterSpacing: '0.02em',
                          textTransform: 'uppercase',
                          whiteSpace: 'nowrap',
                          flexShrink: 0,
                        }}
                      >
                        On Hold
                      </span>
                    )}
                  </span>
                </button>
              );
            })}
        </div>
      </div>

      {/* PRIMARY CONTENT PANEL: Render below the primary card (NOT inside a tall flex column) */}
      <div>
        {activePrimaryTab === 'user-details' && (
          <UserDetails userDetails={userDetails} paymentDetails={paymentDetails} />
        )}

        {activePrimaryTab === 'payment-details' && (
          <PaymentDetails
            formDetails={formDetails}
            paymentDetails={paymentDetails}
            userName={userDetails.name}
            userEmail={userDetails.email}
            onPaymentStatusUpdate={handlePaymentStatusUpdate}
            paymentStatusLoading={paymentStatusLoading}
            orderRefund={orderRefund}
          />
        )}

        {currentUserRole !== 'Accountant' &&
          members?.map((member: any) => {
            const tabId = `member-${member?.id}`;
            if (activePrimaryTab !== tabId) return null;
            const secondaryTabId = activeSecondaryTabs[member?.id] || `notes-${member?.id}`;

            return (
              <div>
                <div
                  key={member?.id}
                  style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}
                >
                  <style>{`
                  .sidebar-menu-btn:hover {
                    background-color: #f8fafc !important;
                    border-color: #cbd5e1 !important;

                    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04) !important;
                  }
                  .sidebar-menu-btn:active {

                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06) !important;
                  }
                `}</style>
                  {/* LEFT MENU PANEL: Secondary Tabs (sticky sidebar) */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      width: '240px',
                      flexShrink: 0,
                      position: 'sticky',
                      top: '16px',
                      padding: '12px 10px',
                      borderRadius: '10px',
                      border: '1px solid #e2e8f0',
                      backgroundColor: '#ffffff',
                      zIndex: 5,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                        gap: '2px',
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `notes-${member?.id}`,
                          }));
                          fetchMemberNotes(member.id);
                        }}
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `notes-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `notes-${member?.id}` ? '#eff6ff' : '#ffffff',
                          color: secondaryTabId === `notes-${member?.id}` ? '#075dc5' : '#334155',
                          fontWeight: secondaryTabId === `notes-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `notes-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `notes-${member?.id}` ? '#dbeafe' : '#f1f5f9',
                            color: secondaryTabId === `notes-${member?.id}` ? '#075dc5' : '#64748b',
                          }}
                        >
                          <TagsOutlined style={{ fontSize: '15px' }} />
                        </div>
                        Add Note
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `stage-history-${member?.id}`,
                          }))
                        }
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `stage-history-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `stage-history-${member?.id}`
                              ? '#eff6ff'
                              : '#ffffff',
                          color:
                            secondaryTabId === `stage-history-${member?.id}`
                              ? '#075dc5'
                              : '#334155',
                          fontWeight: secondaryTabId === `stage-history-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `stage-history-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `stage-history-${member?.id}`
                                ? '#dbeafe'
                                : '#f1f5f9',
                            color:
                              secondaryTabId === `stage-history-${member?.id}`
                                ? '#075dc5'
                                : '#64748b',
                          }}
                        >
                          <History size={15} strokeWidth={2.25} />
                        </div>
                        Stage History
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `documents-${member?.id}`,
                          }))
                        }
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `documents-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `documents-${member?.id}` ? '#eff6ff' : '#ffffff',
                          color:
                            secondaryTabId === `documents-${member?.id}` ? '#075dc5' : '#334155',
                          fontWeight: secondaryTabId === `documents-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `documents-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `documents-${member?.id}` ? '#dbeafe' : '#f1f5f9',
                            color:
                              secondaryTabId === `documents-${member?.id}` ? '#075dc5' : '#64748b',
                          }}
                        >
                          <FileStack size={15} strokeWidth={2.25} />
                        </div>
                        Documents
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `processed-docs-${member?.id}`,
                          }))
                        }
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `processed-docs-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `processed-docs-${member?.id}`
                              ? '#eff6ff'
                              : '#ffffff',
                          color:
                            secondaryTabId === `processed-docs-${member?.id}`
                              ? '#075dc5'
                              : '#334155',
                          fontWeight: secondaryTabId === `processed-docs-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `processed-docs-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `processed-docs-${member?.id}`
                                ? '#dbeafe'
                                : '#f1f5f9',
                            color:
                              secondaryTabId === `processed-docs-${member?.id}`
                                ? '#075dc5'
                                : '#64748b',
                          }}
                        >
                          <ScanLine size={15} strokeWidth={2.25} />
                        </div>
                        Forms by Documitra
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `tracking-${member?.id}`,
                          }))
                        }
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `tracking-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `tracking-${member?.id}` ? '#eff6ff' : '#ffffff',
                          color:
                            secondaryTabId === `tracking-${member?.id}` ? '#075dc5' : '#334155',
                          fontWeight: secondaryTabId === `tracking-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `tracking-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `tracking-${member?.id}` ? '#dbeafe' : '#f1f5f9',
                            color:
                              secondaryTabId === `tracking-${member?.id}` ? '#075dc5' : '#64748b',
                          }}
                        >
                          <LineChart size={15} strokeWidth={2.25} />
                        </div>
                        Tracking Details
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveSecondaryTabs(prev => ({
                            ...prev,
                            [member?.id]: `form-details-${member?.id}`,
                          }))
                        }
                        className="sidebar-menu-btn"
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border:
                            secondaryTabId === `form-details-${member?.id}`
                              ? '1px solid #bcd7ff'
                              : '1px solid #e2e8f0',
                          background:
                            secondaryTabId === `form-details-${member?.id}` ? '#eff6ff' : '#ffffff',
                          color:
                            secondaryTabId === `form-details-${member?.id}` ? '#075dc5' : '#334155',
                          fontWeight: secondaryTabId === `form-details-${member?.id}` ? 600 : 500,
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          borderRadius: '8px',
                          textAlign: 'left',
                          boxShadow:
                            secondaryTabId === `form-details-${member?.id}`
                              ? '0 1px 3px rgba(7, 93, 197, 0.12), inset 0 1px 0 rgba(255,255,255,0.6)'
                              : '0 1px 2px rgba(15, 23, 42, 0.04)',
                          transition: 'all 0.18s ease',
                        }}
                      >
                        <div
                          style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            backgroundColor:
                              secondaryTabId === `form-details-${member?.id}`
                                ? '#dbeafe'
                                : '#f1f5f9',
                            color:
                              secondaryTabId === `form-details-${member?.id}`
                                ? '#075dc5'
                                : '#64748b',
                          }}
                        >
                          <ClipboardList size={15} strokeWidth={2.25} />
                        </div>
                        Form Details
                      </button>

                      {(() => {
                        const onHold = isDocumitraMemberOnHold(member);
                        return (
                          <button
                            type="button"
                            title={
                              onHold
                                ? member?.onHoldRemark
                                  ? `On hold: ${member.onHoldRemark}`
                                  : 'Release the hold on this application'
                                : 'Put this application on hold'
                            }
                            onClick={() => {
                              setHoldRemark(member?.onHoldRemark || '');
                              setHoldModal({ open: true, member });
                            }}
                            className="sidebar-menu-btn"
                            style={{
                              width: '100%',
                              marginTop: '10px',
                              padding: '8px 10px',
                              border: onHold ? '1px solid #fed7aa' : '1px solid #e2e8f0',
                              background: onHold ? '#fff7ed' : '#ffffff',
                              color: onHold ? '#c2410c' : '#334155',
                              fontWeight: 600,
                              fontSize: '14px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              gap: '10px',
                              borderRadius: '8px',
                              textAlign: 'left',
                              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
                              transition: 'all 0.18s ease',
                            }}
                          >
                            <div
                              style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                backgroundColor: onHold ? '#ffedd5' : '#f1f5f9',
                                color: onHold ? '#c2410c' : '#64748b',
                              }}
                            >
                              {onHold ? (
                                <PlayCircle size={15} strokeWidth={2.25} />
                              ) : (
                                <PauseCircle size={15} strokeWidth={2.25} />
                              )}
                            </div>
                            {onHold ? 'On Hold · Release' : 'Put On Hold'}
                          </button>
                        );
                      })()}
                    </div>

                    <div
                      style={{
                        marginTop: '12px',
                        borderRadius: '14px',
                        border: '1px solid #e5e7eb',
                        backgroundColor: '#ffffff',
                        overflow: 'hidden',
                        boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
                      }}
                    >
                      {/* Header: plan + package */}
                      {(paymentDetails?.pricingPlan?.title ||
                        member?.package ||
                        paymentDetails?.packageName) && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '14px 10px',
                            background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
                            borderBottom: '1px solid #eef0f4',
                          }}
                        >
                          <div style={{ minWidth: 0, flex: 1 }}>
                            {paymentDetails?.pricingPlan?.title && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  flexWrap: 'wrap',
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#0f172a',
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {paymentDetails.pricingPlan.title}
                                </span>
                                {(member?.agegroup || member?.ageGroup) && (
                                  <span
                                    style={{
                                      padding: '2px 4px',
                                      borderRadius: '6px',
                                      backgroundColor: '#ffffff',
                                      border: '1px solid #c7d2fe',
                                      color: '#4338ca',
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.04em',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {member?.agegroup || member?.ageGroup}
                                  </span>
                                )}
                              </div>
                            )}
                            {(member?.package || paymentDetails?.packageName) && (
                              <div
                                style={{
                                  display: 'flex',

                                  gap: '6px',
                                  marginTop: '4px',
                                  color: '#64748b',
                                  fontSize: '13px',
                                  fontWeight: 500,
                                }}
                              >
                                <Package
                                  size={13}
                                  style={{ marginTop: '3px' }}
                                  color="#64748b"
                                  stroke="#64748b"
                                />
                                {member?.package || paymentDetails?.packageName}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Add-ons */}
                      {(isAddonSelected(paymentDetails?.expedite) ||
                        isAddonSelected(paymentDetails?.photoEnhancement) ||
                        isAddonSelected(paymentDetails?.apostilled) ||
                        isAddonSelected(paymentDetails?.courierService)) && (
                        <div style={{ padding: '12px 10px 14px' }}>
                          <div
                            style={{
                              fontSize: '11px',
                              fontWeight: 700,
                              color: '#94a3b8',
                              textTransform: 'uppercase',
                              letterSpacing: '0.08em',
                              marginBottom: '8px',
                            }}
                          >
                            Add-ons
                          </div>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                              gap: '8px',
                            }}
                          >
                            {isAddonSelected(paymentDetails?.expedite) && (
                              <div style={addonTile}>
                                <span style={addonCheck}>{checkIcon}</span>
                                Expedite
                              </div>
                            )}
                            {isAddonSelected(paymentDetails?.photoEnhancement) && (
                              <div style={addonTile}>
                                <span style={addonCheck}>{checkIcon}</span>
                                Photo Enhancement
                              </div>
                            )}
                            {isAddonSelected(paymentDetails?.apostilled) && (
                              <div style={addonTile}>
                                <span style={addonCheck}>{checkIcon}</span>
                                {getApostilleLabel(paymentDetails?.apostilled)}
                              </div>
                            )}
                            {isAddonSelected(paymentDetails?.courierService) && (
                              <div style={addonTile}>
                                <span style={addonCheck}>{checkIcon}</span>
                                Courier Service
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* RIGHT CONTENT PANEL: Beside the left sticky menu */}
                  <div style={{ paddingTop: '0', flex: 1, minWidth: 0 }}>
                    {/* Application Status */}
                    <div
                      style={{
                        display: 'flex',
                        gap: '20px',
                        alignItems: 'center',
                        marginBottom: '15px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: '12px',
                          padding: '8px 16px',

                          borderRadius: '8px',
                          border: '1px solid #86efac',
                          overflow: 'visible',
                          width: 'fit-content',
                          backgroundColor: '#f0fdf4',
                          color: '#15803d',
                          fontWeight: 600,
                          boxShadow: '0 2px 8px rgba(34, 197, 94, 0.15)',
                        }}
                      >
                        <Text style={{ fontSize: '16px', fontWeight: '600', minWidth: '80px' }}>
                          Application Status:
                        </Text>
                        <Select
                          style={{ width: 300, fontSize: '16px' }}
                          showSearch
                          optionFilterProp="label"
                          optionLabelProp="displayLabel"
                          filterOption={(input, option) => {
                            const opt = option as unknown as Record<string, any>;
                            const label = String(opt?.searchLabel ?? opt?.name ?? opt?.value ?? '');
                            return label.toLowerCase().includes(input.toLowerCase());
                          }}
                          value={(() => {
                            const statusFromApi =
                              member?.status || formDetails?.memberStatus || formDetails?.status;
                            return getApplicationStatusValue(statusFromApi) || 'Fill Form';
                          })()}
                          onChange={value => {
                            const updatedMembers = members.map((m: any) => {
                              if (m.id === member.id) {
                                return { ...m, status: value };
                              }
                              return m;
                            });
                            setMembers(updatedMembers);
                          }}
                          loading={memberStatusLoadingStates[member.id]}
                          placeholder="Select member status"
                          disabled={memberDetailsLocked}
                          menuItemSelectedIcon={null}
                          options={(() => {
                            const statusFromApi =
                              member?.status || formDetails?.memberStatus || formDetails?.status;
                            const adminStatus = getApplicationStatusValue(statusFromApi);
                            const combinedPackageText = `${formDetails?.pricingPlan?.title || ''} ${paymentDetails?.packageName || ''} ${formDetails?.plan || ''}`;
                            const filteredOptions = getDocumitraMemberStatusOptionsByPlan(
                              combinedPackageText,
                              adminStatus
                            );

                            const isInOptions =
                              adminStatus &&
                              filteredOptions.some(
                                (opt: any) => opt.value === adminStatus || opt.name === adminStatus
                              );

                            let baseOptions: any[] = filteredOptions;
                            if (adminStatus && !isInOptions) {
                              baseOptions = [
                                ...filteredOptions,
                                {
                                  id: `api-${member.id}`,
                                  value: adminStatus,
                                  name: adminStatus,
                                },
                              ];
                            }

                            const currentSelectedValue =
                              getApplicationStatusValue(statusFromApi) || 'Fill Form';

                            return baseOptions.map((opt: any) => {
                              const optionValue = String(opt?.value ?? opt?.name ?? '');
                              const searchLabel = String(
                                opt?.label ?? opt?.name ?? optionValue ?? ''
                              );
                              const isSelected = optionValue === String(currentSelectedValue);
                              return {
                                ...opt,
                                searchLabel,
                                displayLabel: searchLabel,
                                label: (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px',
                                      padding: '2px 0',
                                      fontSize: '14px',
                                      fontWeight: isSelected ? 600 : 500,
                                      color: isSelected ? '#075dc5' : '#1f2937',
                                      lineHeight: 1.2,
                                      width: '100%',
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '16px',
                                        height: '16px',
                                        borderRadius: '3px',
                                        border: isSelected
                                          ? '2px solid #075dc5'
                                          : '1.5px solid #94a3b8',
                                        backgroundColor: isSelected ? '#075dc5' : '#ffffff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        transition:
                                          'background-color 0.15s ease, border-color 0.15s ease',
                                        boxShadow: isSelected
                                          ? '0 1px 3px rgba(7, 93, 197, 0.3)'
                                          : 'none',
                                      }}
                                    >
                                      {isSelected && (
                                        <Check
                                          size={11}
                                          strokeWidth={3.5}
                                          color="#ffffff"
                                          style={{ display: 'block' }}
                                        />
                                      )}
                                    </div>
                                    <span
                                      style={{
                                        flex: 1,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {searchLabel}
                                    </span>
                                  </div>
                                ),
                              };
                            });
                          })()}
                          size="middle"
                        />
                        {getApplicationStatusValue(
                          member?.status || formDetails?.memberStatus || formDetails?.status
                        ) === GOVERNMENT_FEE_PENDING_STATUS &&
                          !memberDetailsLocked &&
                          (() => {
                            const feeDraft = governmentFeeDrafts[member.id] || {
                              paymentAmount: '',
                              paymentFor: GOVERNMENT_FEE_PAYMENT_FOR_OPTIONS[0],
                            };
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  gap: '10px',
                                }}
                              >
                                <div className="floating-field">
                                  <input
                                    type="text"
                                    placeholder="e.g. USD 120.00"
                                    value={feeDraft.paymentAmount}
                                    onChange={e =>
                                      setGovernmentFeeDrafts(prev => ({
                                        ...prev,
                                        [member.id]: {
                                          ...feeDraft,
                                          paymentAmount: e.target.value,
                                        },
                                      }))
                                    }
                                  />
                                  <label>Amount</label>
                                </div>
                                <div className="floating-field">
                                  <select
                                    value={feeDraft.paymentFor}
                                    onChange={e =>
                                      setGovernmentFeeDrafts(prev => ({
                                        ...prev,
                                        [member.id]: {
                                          ...feeDraft,
                                          paymentFor: e.target.value,
                                        },
                                      }))
                                    }
                                  >
                                    {GOVERNMENT_FEE_PAYMENT_FOR_OPTIONS.map(option => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                  <label>Payment requested for</label>
                                </div>
                              </div>
                            );
                          })()}
                        <Button
                          type="primary"
                          onClick={() => handleApplicationStatusUpdate(member)}
                          disabled={
                            memberDetailsLocked ||
                            getApplicationStatusValue(
                              member?.status || formDetails?.memberStatus || formDetails?.status
                            ) ===
                              getApplicationStatusValue(
                                savedMemberStatuses[member.id] ||
                                  member?.status ||
                                  formDetails?.memberStatus ||
                                  formDetails?.status
                              )
                          }
                          loading={memberStatusLoadingStates[member.id]}
                          style={{
                            fontSize: '16px',
                            height: '32px',
                            padding: '0 20px',
                            backgroundColor:
                              !memberDetailsLocked &&
                              getApplicationStatusValue(
                                member?.status || formDetails?.memberStatus || formDetails?.status
                              ) !==
                                getApplicationStatusValue(
                                  savedMemberStatuses[member.id] ||
                                    member?.status ||
                                    formDetails?.memberStatus ||
                                    formDetails?.status
                                )
                                ? '#004195'
                                : undefined,
                            borderColor:
                              !memberDetailsLocked &&
                              getApplicationStatusValue(
                                member?.status || formDetails?.memberStatus || formDetails?.status
                              ) !==
                                getApplicationStatusValue(
                                  savedMemberStatuses[member.id] ||
                                    member?.status ||
                                    formDetails?.memberStatus ||
                                    formDetails?.status
                                )
                                ? '#004195'
                                : undefined,
                            borderRadius: '4px',
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                    <div>
                      {secondaryTabId === `form-details-${member?.id}` &&
                        (member?.formData ? (
                          getMemberFormData(
                            member,
                            <InvertFillButton onClick={() => handleDownloadForm(member)}>
                              Download Form
                            </InvertFillButton>
                          )
                        ) : (
                          <div>User hasn't filled the form yet.</div>
                        ))}

                      {secondaryTabId === `documents-${member?.id}` &&
                        getMemberDocumentsData(member)}

                      {secondaryTabId === `tracking-${member?.id}` && (
                        <div>
                          {renderGovernmentStatusStrip(member)}
                          <DocumitraAdditionalDetail
                            memberId={member?.id}
                            referenceNumber={member?.referenceNumber || ''}
                            dateOfBirth={member?.dateOfBirth ? member?.dateOfBirth : ' '}
                            passportNumber={member?.passportNumber ? member?.passportNumber : ' '}
                            trackingLink={member?.trackingLink || ''}
                            onUpdate={(values: any) =>
                              setMembers((prevMembers: any[]) =>
                                prevMembers.map((m: any) =>
                                  m.id === member.id ? { ...m, ...values } : m
                                )
                              )
                            }
                          />
                          <FinalEmailTrackingDetail
                            memberId={member?.id}
                            finalEmailTrackingDetails={getFinalEmailTrackingDetails(member)}
                            onUpdate={(values: any) =>
                              updateMemberTrackingDetailsInState(member?.id, values)
                            }
                          />
                        </div>
                      )}

                      {secondaryTabId === `processed-docs-${member?.id}` &&
                        (() => {
                          const allDocuments = getAllDocuments(member);
                          const memberExistingPdfStatus = existingPdfStatus[member.id];

                          if (allDocuments.length > 0) {
                            return (
                              <div
                                style={{
                                  width: '100%',
                                  borderRadius: '10px',
                                  border: '1px solid #e2e8f0',
                                  background: '#fff',
                                  padding: '18px 20px',
                                  marginBottom: '18px',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.06em',
                                    color: 'black',
                                    marginBottom: '14px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid #e2e8f0',
                                    lineHeight: 1.2,
                                    gap: '12px',
                                    flexWrap: 'wrap',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px',
                                      flexWrap: 'wrap',
                                    }}
                                  >
                                    <span>Draft Uploaded</span>
                                    <span
                                      style={{
                                        padding: '1px 9px',
                                        borderRadius: '999px',
                                        border: '1px solid #cbd5e1',
                                        background: '#f8fafc',
                                        color: '#475569',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        letterSpacing: '0.02em',
                                        textTransform: 'none',
                                      }}
                                    >
                                      {allDocuments.length} file
                                      {allDocuments.length === 1 ? '' : 's'}
                                    </span>
                                    <span
                                      style={{
                                        padding: '1px 9px',
                                        borderRadius: '999px',
                                        border: '1px solid #fed7aa',
                                        background: '#fff7ed',
                                        color: '#c2410c',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        letterSpacing: '0.02em',
                                        textTransform: 'none',
                                      }}
                                    >
                                      Auto-deletes after {PREVIEW_FORM_RETENTION_DAYS} days
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => handleUpdateAllPdfs(member?.id, allDocuments)}
                                    style={{
                                      backgroundColor: '#004195',
                                      borderRadius: '6px',
                                      color: 'white',
                                      fontWeight: 600,
                                      border: 'none',
                                      cursor: 'pointer',
                                      fontSize: '16px',
                                      padding: '8px 16px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      height: '40px !important',
                                      gap: '8px',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    }}
                                    disabled={updateAllLoading}
                                  >
                                    {updateAllLoading && (
                                      <Spin size="small" style={{ color: 'white' }} />
                                    )}
                                    {updateAllLoading ? 'Processing...' : 'Update Draft Docs'}
                                  </button>
                                </div>
                                <Text
                                  style={{
                                    fontSize: '13px',
                                    color: '#64748b',
                                    marginBottom: '15px',
                                    display: 'block',
                                  }}
                                >
                                  Visible to the applicant for review. Each file is automatically
                                  deleted {PREVIEW_FORM_RETENTION_DAYS} days after upload.
                                </Text>

                                <div
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    gap: '12px',
                                    marginBottom: '15px',
                                  }}
                                >
                                  {allDocuments.map((doc: any, index: number) => {
                                    const remainingDays = (() => {
                                      if (!doc?.expiresAt) return null;
                                      const date = new Date(doc.expiresAt);
                                      if (Number.isNaN(date.getTime())) return null;
                                      return Math.max(
                                        0,
                                        Math.ceil(
                                          (date.getTime() - Date.now()) / (1000 * 60 * 60 * 24)
                                        )
                                      );
                                    })();
                                    const expiryLabel = doc?.expiresAt
                                      ? new Date(doc.expiresAt).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric',
                                        })
                                      : '';

                                    return (
                                      <div
                                        key={doc.id}
                                        style={{
                                          position: 'relative',
                                          borderRadius: '8px',
                                          padding: '10px',
                                          backgroundColor:
                                            doc?.status === true
                                              ? '#90EE90'
                                              : doc?.status === false
                                                ? '#fb8775'
                                                : doc?.remark
                                                  ? '#fffbe6'
                                                  : '#ffffff',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          minHeight: '280px',
                                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        }}
                                      >
                                        <div
                                          style={{
                                            position: 'absolute',
                                            top: '16px',
                                            left: '16px',
                                            zIndex: 1,
                                            padding: '4px 9px',
                                            borderRadius: '4px',
                                            backgroundColor:
                                              doc?.status === true
                                                ? '#28a745'
                                                : doc?.status === false
                                                  ? '#dc3545'
                                                  : '#53657f',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: 600,
                                            lineHeight: 1.2,
                                          }}
                                        >
                                          {doc?.status === true
                                            ? 'Accepted'
                                            : doc?.status === false
                                              ? 'Rejected'
                                              : 'Pending'}
                                        </div>
                                        <div
                                          style={{
                                            width: '100%',
                                            height: '200px',
                                            marginBottom: '10px',
                                            borderRadius: '4px',
                                            overflow: 'hidden',
                                            backgroundColor: '#f8fafc',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <PdfViewer photo={doc?.url} isSmallPreview={true} />
                                        </div>
                                        <div className="processed_data_text" style={{ flex: 1 }}>
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'flex-start',
                                              marginBottom: '4px',
                                              gap: '8px',
                                            }}
                                          >
                                            <Text
                                              style={{
                                                fontSize: '15px',
                                                color: '#666',
                                                wordBreak: 'break-word',
                                                flex: 1,
                                                lineHeight: '1.2',
                                              }}
                                            >
                                              {doc?.name || 'Untitled'}
                                            </Text>
                                            <div
                                              style={{
                                                display: 'flex',
                                                gap: '6px',
                                                flexShrink: 0,
                                              }}
                                            >
                                              {deleteLoadingStates[`${member.id}-${doc.id}`] ? (
                                                <div
                                                  style={{
                                                    backgroundColor: '#00000070',
                                                    padding: '4px',
                                                    borderRadius: '4px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '24px',
                                                    height: '24px',
                                                    cursor: 'not-allowed',
                                                  }}
                                                >
                                                  <Spin size="small" style={{ color: 'white' }} />
                                                </div>
                                              ) : (
                                                <DeleteOutlined
                                                  style={{
                                                    backgroundColor: '#00000070',
                                                    padding: '4px',
                                                    borderRadius: '4px',
                                                    fontSize: 16,
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    width: '24px',
                                                    height: '24px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                  }}
                                                  onClick={() =>
                                                    handleDeleteClick(member?.id, doc?.id)
                                                  }
                                                />
                                              )}
                                              <DownloadOutlined
                                                style={{
                                                  backgroundColor: '#00000070',
                                                  borderRadius: '4px',
                                                  padding: '4px',
                                                  fontSize: 16,
                                                  color: 'white',
                                                  cursor: 'pointer',
                                                  width: '24px',
                                                  height: '24px',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                }}
                                                onClick={() => {
                                                  const link = document.createElement('a');
                                                  link.href =
                                                    doc?.url?.startsWith('https') || !doc?.url
                                                      ? doc?.url
                                                      : `${BASE_IMAGE_URL}/${doc?.url}`;
                                                  link.setAttribute(
                                                    'download',
                                                    doc?.name || 'document.pdf'
                                                  );
                                                  document.body.appendChild(link);
                                                  link.click();
                                                  document.body.removeChild(link);
                                                }}
                                              />
                                            </div>
                                          </div>
                                          <Text
                                            style={{
                                              fontSize: '15px',
                                              color: '#666',
                                              display: 'block',
                                              marginBottom: '4px',
                                              lineHeight: '1.2',
                                              whiteSpace: 'pre-wrap',
                                            }}
                                          >
                                            Remark: {doc?.remark ? doc?.remark : 'N/A'}
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: '12px',
                                              display: 'block',
                                              marginTop: '4px',
                                              fontWeight: 600,
                                              color:
                                                remainingDays !== null && remainingDays <= 5
                                                  ? '#b91c1c'
                                                  : '#c2410c',
                                            }}
                                          >
                                            {doc?.expiresAt
                                              ? `Auto-deletes on ${expiryLabel}${
                                                  remainingDays !== null
                                                    ? ` (${remainingDays} day${
                                                        remainingDays === 1 ? '' : 's'
                                                      } left)`
                                                    : ''
                                                }`
                                              : `Auto-deletes ${PREVIEW_FORM_RETENTION_DAYS} days after upload`}
                                          </Text>
                                        </div>
                                        <input
                                          type="file"
                                          id={`replace-pdf-${member.id}-${doc.id}`}
                                          accept="application/pdf"
                                          style={{ display: 'none' }}
                                          onChange={e => handleDocumentUpload(e, member, doc.id)}
                                        />
                                      </div>
                                    );
                                  })}
                                  <label
                                    htmlFor={`additional-avatar-${member.id}`}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '10px',
                                      padding: '10px',
                                      minHeight: '280px',
                                      border: '2px dashed #cbd5e1',
                                      borderRadius: '8px',
                                      backgroundColor: '#fafafa',
                                      cursor: 'pointer',
                                      transition:
                                        'border-color 0.15s ease, background-color 0.15s ease',
                                      userSelect: 'none',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                                    }}
                                    onMouseEnter={e => {
                                      e.currentTarget.style.borderColor = '#004195';
                                      e.currentTarget.style.backgroundColor = '#f0f6ff';
                                    }}
                                    onMouseLeave={e => {
                                      e.currentTarget.style.borderColor = '#cbd5e1';
                                      e.currentTarget.style.backgroundColor = '#fafafa';
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '50%',
                                        border: '2px solid #004195',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#004195',
                                        fontSize: '28px',
                                        fontWeight: 300,
                                        lineHeight: 1,
                                      }}
                                    >
                                      +
                                    </div>
                                    <div
                                      style={{
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#004195',
                                        letterSpacing: '0.02em',
                                      }}
                                    >
                                      Upload Doc
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                                      Click to select a PDF file
                                    </div>
                                  </label>
                                </div>
                                <input
                                  onChange={e => handleDocumentUpload(e, member)}
                                  type="file"
                                  id={`additional-avatar-${member.id}`}
                                  name="avatar"
                                  accept="application/pdf"
                                  key={`additional-avatar-${member.id}-${Date.now()}`}
                                  style={{ display: 'none' }}
                                />
                              </div>
                            );
                          } else {
                            return (
                              <div
                                style={{
                                  width: '100%',
                                  borderRadius: '10px',
                                  border: '1px solid #e2e8f0',
                                  background: '#fff',
                                  padding: '18px 20px',
                                  marginBottom: '18px',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    flexWrap: 'wrap',
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.06em',
                                    color: 'black',
                                    marginBottom: '14px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid #e2e8f0',
                                    lineHeight: 1.2,
                                  }}
                                >
                                  <span>Upload Draft</span>
                                  <span
                                    style={{
                                      padding: '1px 9px',
                                      borderRadius: '999px',
                                      border: '1px solid #fed7aa',
                                      background: '#fff7ed',
                                      color: '#c2410c',
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      letterSpacing: '0.02em',
                                      textTransform: 'none',
                                    }}
                                  >
                                    Auto-deletes after {PREVIEW_FORM_RETENTION_DAYS} days
                                  </span>
                                </div>
                                <Text
                                  style={{
                                    fontSize: '13px',
                                    color: '#64748b',
                                    marginBottom: '15px',
                                    display: 'block',
                                  }}
                                >
                                  Each draft file is automatically deleted{' '}
                                  {PREVIEW_FORM_RETENTION_DAYS} days after upload.
                                </Text>
                                {memberExistingPdfStatus &&
                                  memberExistingPdfStatus.hasExistingPdfs && (
                                    <div
                                      style={{
                                        marginBottom: '15px',
                                        padding: '10px',
                                        backgroundColor: '#fff7e6',
                                        border: '1px solid #ffd591',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                      }}
                                    >
                                      <span style={{ color: '#fa8c16', fontSize: '16px' }}>⚠️</span>
                                      <Text
                                        style={{
                                          fontSize: '16px',
                                          color: '#d46b08',
                                        }}
                                      >
                                        PDF is already updated for this user. Found{' '}
                                        {memberExistingPdfStatus.existingDocumentsCount} existing
                                        document(s).
                                      </Text>
                                    </div>
                                  )}
                                <div
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(5, 1fr)',
                                    gap: '12px',
                                    marginBottom: '15px',
                                  }}
                                >
                                  <label
                                    htmlFor={`avatar-${member.id}`}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '10px',
                                      padding: '10px',
                                      minHeight: '280px',
                                      border: '2px dashed #cbd5e1',
                                      borderRadius: '8px',
                                      backgroundColor: '#fafafa',
                                      cursor: 'pointer',
                                      transition:
                                        'border-color 0.15s ease, background-color 0.15s ease',
                                      userSelect: 'none',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                                    }}
                                    onMouseEnter={e => {
                                      e.currentTarget.style.borderColor = '#004195';
                                      e.currentTarget.style.backgroundColor = '#f0f6ff';
                                    }}
                                    onMouseLeave={e => {
                                      e.currentTarget.style.borderColor = '#cbd5e1';
                                      e.currentTarget.style.backgroundColor = '#fafafa';
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '50%',
                                        border: '2px solid #004195',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#004195',
                                        fontSize: '28px',
                                        fontWeight: 300,
                                        lineHeight: 1,
                                      }}
                                    >
                                      +
                                    </div>
                                    <div
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: '#004195',
                                        letterSpacing: '0.02em',
                                      }}
                                    >
                                      Upload Doc
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                                      Click to select a PDF file
                                    </div>
                                  </label>
                                </div>
                                <input
                                  onChange={e => handleDocumentUpload(e, member)}
                                  type="file"
                                  id={`avatar-${member.id}`}
                                  name="avatar"
                                  accept="application/pdf"
                                  key={`avatar-${member.id}-${Date.now()}`}
                                  style={{ display: 'none' }}
                                />
                              </div>
                            );
                          }
                        })()}

                      {secondaryTabId === `processed-docs-${member?.id}` && (
                        <>
                          <DocumitraTeamDocuments
                            orderId={formDetails?.id}
                            member={member}
                            documentType={PROCESSED_DOCUMENT_TYPES.FINAL_FORM}
                            onDocumentsChange={(
                              memberIdToUpdate: string,
                              processedDocuments: any[]
                            ) =>
                              setMembers((prevMembers: any[]) =>
                                prevMembers.map((m: any) =>
                                  m.id === memberIdToUpdate
                                    ? { ...m, processedDocuments, processedDocument: null }
                                    : m
                                )
                              )
                            }
                          />
                          <DocumitraTeamDocuments
                            orderId={formDetails?.id}
                            member={member}
                            documentType={PROCESSED_DOCUMENT_TYPES.GOVERNMENT_DOCUMENT}
                            onDocumentsChange={(
                              memberIdToUpdate: string,
                              processedDocuments: any[]
                            ) =>
                              setMembers((prevMembers: any[]) =>
                                prevMembers.map((m: any) =>
                                  m.id === memberIdToUpdate
                                    ? { ...m, processedDocuments, processedDocument: null }
                                    : m
                                )
                              )
                            }
                          />
                        </>
                      )}

                      {secondaryTabId === `stage-history-${member?.id}` && (
                        <OrderStageHistory memberId={member?.id} memberName={member?.name} />
                      )}

                      {secondaryTabId === `notes-${member?.id}` && (
                        <Card
                          style={{ width: '100%', borderRadius: '10px', marginBottom: '18px' }}
                          title="Member Notes"
                        >
                          <div className="member-note-editor">
                            <Text
                              strong
                              className="member-note-field-label"
                              style={{ marginBottom: '10px' }}
                            >
                              New note
                            </Text>
                            <ReactQuill
                              theme="snow"
                              value={newNoteText}
                              onChange={setNewNoteText}
                              placeholder="Enter a note"
                            />
                            <Space className="member-note-actions" style={{ minWidth: '100px' }}>
                              <InvertFillButton
                                variant="blue"
                                size="sm"
                                fontWeight="semibold"
                                onClick={() => handleAddNote(member.id)}
                                disabled={isEmptyNoteHtml(newNoteText)}
                              >
                                Save Note
                              </InvertFillButton>
                            </Space>
                          </div>

                          {notesLoading[member.id] ? (
                            <Spin />
                          ) : memberNotes[member.id]?.length ? (
                            memberNotes[member.id]
                              .slice()
                              .sort(
                                (a: any, b: any) =>
                                  new Date(b.createdAt || b.created_at || 0).getTime() -
                                  new Date(a.createdAt || a.created_at || 0).getTime()
                              )
                              .map((note: any) => {
                                const noteDate = note.createdAt || note.created_at;
                                const addedBy =
                                  note.createdByAdminName ||
                                  note.createdByAdmin?.name ||
                                  note.createdByAdmin?.email ||
                                  note.addedBy ||
                                  note.adminName ||
                                  'Admin';
                                return (
                                  <div className="member-note-field" key={note.id}>
                                    <div className="member-note-field-header">
                                      <div>
                                        <Text
                                          strong
                                          className="member-note-field-label"
                                          style={{ color: '#004195' }}
                                        >
                                          <span style={{ fontWeight: '100', color: '#0f172a' }}>
                                            Added by:
                                          </span>{' '}
                                          {addedBy}
                                        </Text>
                                        <Text type="secondary" className="member-note-meta">
                                          {noteDate && ` on ${new Date(noteDate).toLocaleString()}`}
                                        </Text>
                                      </div>
                                      <InvertFillButton
                                        variant="red"
                                        size="sm"
                                        fontSize="sm"
                                        aria-label="Delete note"
                                        title="Delete note"
                                        onClick={() => handleDeleteNote(member.id, note.id)}
                                      >
                                        <DeleteOutlined />
                                      </InvertFillButton>
                                    </div>
                                    <div className="member-note-content">
                                      <ReactQuill
                                        theme="snow"
                                        value={note.noteText || note.note_text || note.text || ''}
                                        readOnly
                                        modules={{ toolbar: false }}
                                      />
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <Text type="secondary">No notes added yet.</Text>
                          )}
                        </Card>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      <PhotoRemarksModal
        formDetails={formDetails}
        openAddRemark={openAddRemark}
        setOpenAddRemarks={setOpenAddRemarks}
        activePhoto={activePhoto}
        documentName={activeDocName}
        remarkPresets={activeRemarkPresets}
        onRemarkUpdate={handleRemarkUpdate}
      />

      <Modal
        open={holdModal.open}
        onCancel={() => (holdSaving ? undefined : setHoldModal({ open: false }))}
        footer={null}
        width={520}
        destroyOnClose
        title={
          isDocumitraMemberOnHold(holdModal.member)
            ? `Release hold — ${holdModal.member?.name || ''}`
            : `Put on hold — ${holdModal.member?.name || ''}`
        }
      >
        {(() => {
          const onHold = isDocumitraMemberOnHold(holdModal.member);
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text type="secondary" style={{ fontSize: '13px' }}>
                {onHold
                  ? 'The "On Hold" tag will be removed from this member. The application status is not changed.'
                  : 'Adds an "On Hold" tag to this member (shown on the member tab and the order list). The application status is not changed and the applicant is not notified.'}
              </Text>
              {!onHold && (
                <div>
                  <Text strong style={{ display: 'block', marginBottom: '6px', fontSize: '13px' }}>
                    Reason / remark (optional)
                  </Text>
                  <Input.TextArea
                    value={holdRemark}
                    onChange={e => setHoldRemark(e.target.value)}
                    placeholder="Why is this application on hold?"
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    maxLength={2000}
                  />
                </div>
              )}
              {onHold && holdModal.member?.onHoldRemark && (
                <div
                  style={{
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid #fed7aa',
                    backgroundColor: '#fff7ed',
                    fontSize: '13px',
                    color: '#9a3412',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  <strong>Current remark:</strong> {holdModal.member.onHoldRemark}
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                  paddingTop: '10px',
                  borderTop: '1px solid #f1f5f9',
                }}
              >
                <InvertFillButton
                  variant="white"
                  fontSize="base"
                  fontWeight="medium"
                  onClick={() => setHoldModal({ open: false })}
                  disabled={holdSaving}
                >
                  Cancel
                </InvertFillButton>
                <InvertFillButton
                  variant={onHold ? 'blue' : 'red'}
                  fontSize="base"
                  fontWeight="semibold"
                  onClick={() => handleMemberHoldUpdate(holdModal.member, !onHold, holdRemark)}
                  disabled={holdSaving}
                >
                  {holdSaving ? 'Saving...' : onHold ? 'Release Hold' : 'Put On Hold'}
                </InvertFillButton>
              </div>
            </div>
          );
        })()}
      </Modal>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: 10,
                background: '#eff6ff',
              }}
            >
              <Package size={20} strokeWidth={2} color="#075dc5" />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: '#172033',
                  lineHeight: 1.2,
                }}
              >
                Final Email Tracking Details
              </span>
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#64748b',
                  lineHeight: 1.2,
                }}
              >
                Shipment &amp; carrier information overview
              </span>
            </div>
          </div>
        }
        open={viewFinalEmailModal.open}
        onCancel={() => setViewFinalEmailModal({ open: false })}
        footer={null}
        destroyOnClose
        width={540}
      >
        {(() => {
          const details = getFinalEmailTrackingDetails(viewFinalEmailModal.member);
          const fields = [
            {
              icon: <Barcode size={18} strokeWidth={2} color="#075dc5" />,
              label: 'Tracking ID',
              value: details?.trackingId || '—',
            },
            {
              icon: <Truck size={18} strokeWidth={2} color="#075dc5" />,
              label: 'Carrier Name',
              value: details?.carrierName || '—',
            },
          ];
          const linkValue = details?.trackingLink;
          return (
            <div style={{ padding: '4px 0 8px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {fields.map(f => (
                  <div key={f.label}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 32,
                          height: 32,
                          borderRadius: 6,
                          background: '#eff6ff',
                          flexShrink: 0,
                        }}
                      >
                        {f.icon}
                      </div>
                      <span
                        style={{
                          fontSize: 15,
                          fontWeight: 500,
                          color: '#64748b',
                        }}
                      >
                        {f.label}
                      </span>
                    </div>
                    <div style={{ paddingLeft: 42, marginTop: 4 }}>
                      <span
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: '#172033',
                        }}
                      >
                        {f.value}
                      </span>
                    </div>
                  </div>
                ))}
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: 6,
                        background: '#eff6ff',
                        flexShrink: 0,
                      }}
                    >
                      <ExternalLink size={18} strokeWidth={2} color="#075dc5" />
                    </div>
                    <span
                      style={{
                        fontSize: 15,
                        fontWeight: 500,
                        color: '#64748b',
                      }}
                    >
                      Tracking Link
                    </span>
                  </div>
                  <div style={{ paddingLeft: 42, marginTop: 4 }}>
                    {linkValue ? (
                      <a
                        href={linkValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: '#075dc5',
                          wordBreak: 'break-all',
                        }}
                      >
                        {linkValue}
                      </a>
                    ) : (
                      <span
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: '#172033',
                        }}
                      >
                        —
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: 12,
                  marginTop: 24,
                  paddingTop: 16,
                  borderTop: '1px solid #eef2f7',
                }}
              >
                <InvertFillButton
                  variant="white"
                  size="md"
                  fontSize="base"
                  fontWeight="medium"
                  onClick={() => setViewFinalEmailModal({ open: false })}
                >
                  <CircleX size={16} strokeWidth={2} />
                  Close
                </InvertFillButton>
                <InvertFillButton
                  variant="blue"
                  size="md"
                  fontSize="base"
                  fontWeight="semibold"
                  onClick={() => {
                    const member = viewFinalEmailModal.member;
                    setViewFinalEmailModal({ open: false });
                    if (member) {
                      openTrackingDetailsModal(member, FINAL_EMAIL_STATUS);
                    }
                  }}
                >
                  <Pencil size={16} strokeWidth={2} />
                  Edit
                </InvertFillButton>
              </div>
            </div>
          );
        })()}
      </Modal>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: 10,
                background: '#eff6ff',
              }}
            >
              <Package size={20} strokeWidth={2} color="#075dc5" />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: '#172033',
                  lineHeight: 1.2,
                }}
              >
                Final Email Tracking Details
              </span>
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#64748b',
                  lineHeight: 1.2,
                }}
              >
                Shipment &amp; carrier information required before sending
              </span>
            </div>
          </div>
        }
        open={trackingDetailsModal.open}
        onCancel={() => {
          setTrackingDetailsModal({ open: false });
          trackingDetailsForm.resetFields();
        }}
        footer={null}
        destroyOnClose
        width={540}
      >
        <div style={{ padding: '4px 0 8px' }}>
          <Form form={trackingDetailsForm} layout="vertical">
            <Form.Item
              name="trackingId"
              label={
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#172033',
                    marginBottom: 6,
                  }}
                >
                  Tracking ID
                </span>
              }
              rules={[{ required: true, whitespace: true, message: 'Please enter Tracking ID' }]}
              style={{ marginBottom: 18 }}
            >
              <Input
                placeholder="e.g. 1Z999AA10123456784"
                size="large"
                style={{
                  borderRadius: 8,
                  height: 44,
                  paddingLeft: 8,
                }}
                prefix={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      paddingRight: 10,
                      borderRight: '1px solid #e2e8f0',
                      marginRight: 6,
                    }}
                  >
                    <Barcode size={17} color="#64748b" />
                  </div>
                }
              />
            </Form.Item>

            <Form.Item
              name="carrierName"
              label={
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#172033',
                    marginBottom: 6,
                  }}
                >
                  Carrier Name
                </span>
              }
              rules={[{ required: true, whitespace: true, message: 'Please enter Carrier Name' }]}
              style={{ marginBottom: 18 }}
            >
              <Input
                placeholder="e.g. FedEx, DHL, UPS, India Post"
                size="large"
                style={{
                  borderRadius: 8,
                  height: 44,
                  paddingLeft: 8,
                }}
                prefix={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      paddingRight: 10,
                      borderRight: '1px solid #e2e8f0',
                      marginRight: 6,
                    }}
                  >
                    <Truck size={17} color="#64748b" />
                  </div>
                }
              />
            </Form.Item>

            <Form.Item
              name="trackingLink"
              label={
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#172033',
                    marginBottom: 6,
                  }}
                >
                  Tracking Link
                </span>
              }
              rules={[{ required: true, whitespace: true, message: 'Please enter Tracking Link' }]}
              style={{ marginBottom: 4 }}
            >
              <Input
                placeholder="https://www.carrier.com/track?id=..."
                size="large"
                style={{
                  borderRadius: 8,
                  height: 44,
                  paddingLeft: 8,
                }}
                prefix={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      paddingRight: 10,
                      borderRight: '1px solid #e2e8f0',
                      marginRight: 6,
                    }}
                  >
                    <ExternalLink size={17} color="#64748b" />
                  </div>
                }
              />
            </Form.Item>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 12,
                marginTop: 20,
                paddingTop: 16,
                borderTop: '1px solid #eef2f7',
              }}
            >
              <InvertFillButton
                variant="white"
                size="md"
                fontSize="base"
                fontWeight="medium"
                onClick={() => {
                  setTrackingDetailsModal({ open: false });
                  trackingDetailsForm.resetFields();
                }}
              >
                <CircleX size={16} strokeWidth={2} />
                Cancel
              </InvertFillButton>
              <InvertFillButton
                variant="blue"
                size="md"
                fontSize="base"
                fontWeight="semibold"
                onClick={submitTrackingDetailsAndStatus}
                disabled={
                  trackingDetailsSaving ||
                  memberStatusLoadingStates[trackingDetailsModal.member?.id]
                }
              >
                <CircleCheckBig size={16} strokeWidth={2} />
                {trackingDetailsSaving || memberStatusLoadingStates[trackingDetailsModal.member?.id]
                  ? 'Saving...'
                  : 'Save & Update Status'}
              </InvertFillButton>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: 10,
                background: '#eff6ff',
              }}
            >
              <FileStack size={20} strokeWidth={2} color="#075dc5" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: '#172033',
                }}
              >
                Select Document Type
              </span>
              <span style={{ fontSize: 13, fontWeight: 500, color: '#64748b' }}>
                Classify this document for easier processing
              </span>
            </div>
          </div>
        }
        open={!!docTypeModalPhoto}
        onCancel={closeDocTypeModal}
        footer={null}
        width={560}
        destroyOnClose
      >
        <div style={{ padding: '4px 0 8px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <Text strong style={{ fontSize: 15, fontWeight: 500, color: '#64748b' }}>
                Search Document Type Directly
              </Text>
            </div>
            <Select
              size="large"
              style={{ width: '100%' }}
              showSearch
              allowClear
              optionLabelProp="plainLabel"
              placeholder="Search and select document type directly"
              value={selectedDocType}
              onChange={val => {
                if (val) {
                  const categoryMatch = DOCUMENT_TYPE_TAXONOMY.find(c => c.types.includes(val));
                  if (categoryMatch) {
                    setSelectedDocCategory(categoryMatch.category);
                  }
                }
                setSelectedDocType(val || undefined);
              }}
              options={DOCUMENT_TYPE_TAXONOMY.flatMap(c => c.types).map(t => ({
                plainLabel: t,
                value: t,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      padding: '2px 0',
                      fontSize: 14,
                      fontWeight: selectedDocType === t ? 600 : 500,
                      color: selectedDocType === t ? '#075dc5' : '#1f2937',
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: 3,
                        border: selectedDocType === t ? '2px solid #075dc5' : '1.5px solid #94a3b8',
                        backgroundColor: selectedDocType === t ? '#075dc5' : '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {selectedDocType === t && (
                        <Check size={11} strokeWidth={3.5} color="#ffffff" />
                      )}
                    </div>
                    {t}
                  </div>
                ),
              }))}
              filterOption={(input, option) =>
                String(option?.plainLabel ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </div>
          <div
            style={{
              textAlign: 'center',
              margin: '16px 0',
              color: '#94a3b8',
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: '0.08em',
            }}
          >
            OR
          </div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <Text strong style={{ fontSize: 15, fontWeight: 500, color: '#64748b' }}>
                Category
              </Text>
            </div>
            <Select
              size="large"
              style={{ width: '100%' }}
              showSearch
              optionLabelProp="plainLabel"
              placeholder="Select category (e.g. Passport, Identity Cards)"
              value={selectedDocCategory}
              onChange={val => {
                setSelectedDocCategory(val);
                setSelectedDocType(undefined);
              }}
              options={DOCUMENT_CATEGORIES.map(c => ({
                plainLabel: c,
                value: c,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      padding: '2px 0',
                      fontSize: 14,
                      fontWeight: selectedDocCategory === c ? 600 : 500,
                      color: selectedDocCategory === c ? '#075dc5' : '#1f2937',
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: 3,
                        border:
                          selectedDocCategory === c ? '2px solid #075dc5' : '1.5px solid #94a3b8',
                        backgroundColor: selectedDocCategory === c ? '#075dc5' : '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {selectedDocCategory === c && (
                        <Check size={11} strokeWidth={3.5} color="#ffffff" />
                      )}
                    </div>
                    {c}
                  </div>
                ),
              }))}
              filterOption={(input, option) =>
                String(option?.plainLabel ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <Text strong style={{ fontSize: 15, fontWeight: 500, color: '#64748b' }}>
                Document Type
              </Text>
            </div>
            <Select
              size="large"
              style={{ width: '100%' }}
              showSearch
              optionLabelProp="plainLabel"
              placeholder={selectedDocCategory ? 'Select document type' : 'Select a category first'}
              value={selectedDocType}
              onChange={val => setSelectedDocType(val)}
              disabled={!selectedDocCategory}
              options={getDocumentTypesForCategory(selectedDocCategory).map(t => ({
                plainLabel: t,
                value: t,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      padding: '2px 0',
                      fontSize: 14,
                      fontWeight: selectedDocType === t ? 600 : 500,
                      color: selectedDocType === t ? '#075dc5' : '#1f2937',
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: 3,
                        border: selectedDocType === t ? '2px solid #075dc5' : '1.5px solid #94a3b8',
                        backgroundColor: selectedDocType === t ? '#075dc5' : '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {selectedDocType === t && (
                        <Check size={11} strokeWidth={3.5} color="#ffffff" />
                      )}
                    </div>
                    {t}
                  </div>
                ),
              }))}
              filterOption={(input, option) =>
                String(option?.plainLabel ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 12,
              marginTop: 20,
              paddingTop: 16,
              borderTop: '1px solid #eef2f7',
            }}
          >
            <InvertFillButton
              variant="white"
              size="md"
              fontSize="base"
              fontWeight="medium"
              onClick={closeDocTypeModal}
            >
              <CircleX size={16} strokeWidth={2} />
              Cancel
            </InvertFillButton>
            <InvertFillButton
              variant="blue"
              size="md"
              fontSize="base"
              fontWeight="semibold"
              onClick={handleSaveDocumentType}
              disabled={docTypeSaving}
            >
              <CircleCheckBig size={16} strokeWidth={2} />
              {docTypeSaving ? 'Saving...' : 'Save'}
            </InvertFillButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ReviewDocumitraOrder;
